// import React, { useEffect, useRef, useState } from "react";
// import styles from "./ForwardInstructions.module.css";
// import AnimatedButton from "../AnimatedButton/AnimatedButton";
// import { useNavigate, useLocation } from "react-router-dom";
// import { API_BASE_URL, fetchAgentDetailById, updateAgent, startForwardingTestCall, getForwardingTestCallStatus } from "../../Store/apiStore";
// import { useAgentStore } from "../../Store/agentDetailStore";
// import decodeToken from "../../lib/decodeToken";
// import Loader2 from "../Loader2/Loader2";
// import Modal from "../Modal/Modal";

// import PopUp from "../Popup/Popup";

// // Kept in sync with SelectCarrier.js `categories`. Each MVNO uses its
// // parent network's dial codes — Cricket/Metro/Boost/Mint/Consumer
// // Cellular/Google Fi ride T-Mobile or AT&T GSM (**21*{number}#); Visible/
// // Xfinity/Spectrum ride Verizon CDMA (*72{number}). Canadian flanker
// // brands follow their parent (Fido→Rogers GSM, Koodo→Telus CDMA,
// // Virgin/Lucky→Bell CDMA, Chatr→Rogers GSM, Public→Telus CDMA).
// const callForwardingConfig = {
//   // 🇺🇸 US — majors (GSM)
//   "AT&T": { activate: "**21*{number}#", deactivate: "##21#" },
//   "T-Mobile US": { activate: "**21*{number}#", deactivate: "##21#" },

//   // 🇺🇸 US — majors (CDMA)
//   "Verizon": { activate: "*72{number}", deactivate: "*73" },
//   "U.S. Cellular": { activate: "*72{number}", deactivate: "*73" },

//   // 🇺🇸 US — MVNOs (GSM, T-Mobile / AT&T backed)
//   "Cricket Wireless": { activate: "**21*{number}#", deactivate: "##21#" },
//   "Metro by T-Mobile": { activate: "**21*{number}#", deactivate: "##21#" },
//   "Boost Mobile": { activate: "**21*{number}#", deactivate: "##21#" },
//   "Mint Mobile": { activate: "**21*{number}#", deactivate: "##21#" },
//   "Consumer Cellular": { activate: "**21*{number}#", deactivate: "##21#" },
//   "Google Fi": { activate: "**21*{number}#", deactivate: "##21#" },

//   // 🇺🇸 US — MVNOs (CDMA, Verizon backed)
//   "Visible": { activate: "*72{number}", deactivate: "*73" },
//   "Xfinity Mobile": { activate: "*72{number}", deactivate: "*73" },
//   "Spectrum Mobile": { activate: "*72{number}", deactivate: "*73" },

//   // 🇨🇦 Canada — majors (GSM)
//   "Rogers": { activate: "**21*{number}#", deactivate: "##21#" },
//   "Freedom Mobile": { activate: "**21*{number}#", deactivate: "##21#" },

//   // 🇨🇦 Canada — majors (CDMA)
//   "Bell": { activate: "*72{number}", deactivate: "*73" },
//   "Telus": { activate: "*72{number}", deactivate: "*73" },

//   // 🇨🇦 Canada — flanker brands
//   "Fido": { activate: "**21*{number}#", deactivate: "##21#" },
//   "Chatr Mobile": { activate: "**21*{number}#", deactivate: "##21#" },
//   "Koodo": { activate: "*72{number}", deactivate: "*73" },
//   "Public Mobile": { activate: "*72{number}", deactivate: "*73" },
//   "Virgin Plus": { activate: "*72{number}", deactivate: "*73" },
//   "Lucky Mobile": { activate: "*72{number}", deactivate: "*73" },
// };

// // DEV/UI flag — when true, "Call Now" just opens the "Connecting Call…"
// // popup and FREEZES it there (no real call, no polling, no auto-advance to
// // success/fail) so the connecting UI can be styled. Flip back to `false`
// // to restore the normal test-call flow.
// const FREEZE_CONNECTING_POPUP = false;

// const ForwardInstructions = ({
//   // Wizard integration — when true, exit paths hand off to the provided
//   // callbacks instead of routing to /fast-agent-detail. Both CTAs
//   // ("I've done this" via carrier codes, and "Using agent number
//   // directly") also PATCH the agent row so reporting can tell which
//   // forwarding path the user picked.
//   wizardMode = false,
//   onWizardDone,
//   onWizardBack,
//   // Hides the "I will publish AI Receptionist number directly — Dashboard"
//   // escape-hatch CTA. PostPurchaseSetup keeps it visible (default false)
//   // because users coming from a paid checkout may legitimately want to
//   // use the agent number directly. GoLiveWizard passes true so the
//   // post-Number-purchase free-user flow can't bail out of forwarding —
//   // they bought a number, the expectation is they will forward to it.
//   hideDirectPublishCta = false,
//   // agentCtx — passed down by PostPurchaseSetup. Primary source of
//   // truth for the just-purchased voip number, since sessionStorage
//   // (the legacy source) gets wiped when the user closes the tab and
//   // reopens the wizard URL — leaving the steps panel with an empty
//   // phone number even though the agent IS provisioned in the DB.
//   agentCtx,
//   // Agent display name for the "I will publish ${name}'s number directly"
//   // skip-helper line. Defaults to "Sophia" only as a final fallback —
//   // wrappers should pass `agentCtx.agent.agentName` so the user sees
//   // their actual receptionist name.
//   agentName: agentNameProp = "",
// } = {}) => {
//   // Resolved agent name — prefer explicit prop, then agentCtx, then
//   // the default seed name new agents get at creation time.
//   const agentName =
//     agentNameProp ||
//     agentCtx?.agent?.agentName ||
//     agentCtx?.agent?.name ||
//     "Sophia";
//   const {
//     setAgentById,
//     getAgentById,
//   } = useAgentStore();
//   const navigate = useNavigate();
//   const location = useLocation();
//   const token = localStorage.getItem("token") || "";
//   const decodeTokenData = decodeToken(token);
//   const userId = decodeTokenData?.id || "";
//   // ── Carrier resolution — 4-layered fallback ──────────────────────
//   // Earlier carrier was read only from location.state OR sessionStorage,
//   // both of which die when the user closes the tab. Result: a reopened
//   // wizard fell through to the `*72{number}` default (Verizon CDMA),
//   // which dialed the WRONG forwarding code for AT&T / T-Mobile / etc.
//   // users → carrier-side forwarding silently broke. Fallback chain:
//   //
//   //   Layer 1: location.state.carrier        (direct navigation, fresh)
//   //   Layer 2: sessionStorage["selectedCarrier"]  (per-tab cache)
//   //   Layer 3: localStorage scoped by agentId     (browser-close survival)
//   //   Layer 4: agentCtx.agent.forwardingCarrier   (DB, only if previously saved)
//   //
//   // First non-empty wins. Read at render time so component picks up
//   // updates from any layer without explicit subscription.
//   const _agentIdForCarrier = sessionStorage.getItem("SelectAgentId");
//   const carrierFromState = location?.state?.carrier;
//   const carrierFromSession = sessionStorage.getItem("selectedCarrier");
//   let carrierFromLocal = "";
//   try {
//     if (_agentIdForCarrier) {
//       carrierFromLocal = localStorage.getItem(`postPurchase.carrier.${_agentIdForCarrier}`) || "";
//     }
//   } catch {
//     /* private mode quota — silent fallback to other layers */
//   }
//   const carrierFromAgent = agentCtx?.agent?.forwardingCarrier || "";
//   const carrier =
//     carrierFromState ||
//     carrierFromSession ||
//     carrierFromLocal ||
//     carrierFromAgent ||
//     "";
//   // const token = localStorage.getItem("token") || "";
//   // const { id: userId } = decodeToken(token) || {};
//   const [doneLoading, setDoneLoading] = useState(false);


//   // Config get karo
//   const config = callForwardingConfig[carrier] || {
//     activate: "*72{number}",
//     deactivate: "*73",
//   };

//   const isInitialLoad = useRef(true);
//   const [showPopup, setShowPopup] = useState(false);
//   const [popupType, setPopupType] = useState("");
//   const [popupMessage, setPopupMessage] = useState("");
//   const [selectedNumber, setSelectedNumber] = useState("");
//   // Mobile-only "Do it now" → tel: dialer flow.
//   //
//   // We detect ONLY phones (iPhone + Android phones). Tablets are
//   // intentionally treated as desktop because (a) iPads can't dial
//   // standard *72 carrier codes and (b) Android tablets often lack a
//   // SIM. Strict UA sniff — modern phones still report "Mobile" in UA.
//   //
//   // hasOpenedDialer flips to true the FIRST time the user returns to
//   // the tab after tapping "Do it now" (visibilitychange listener
//   // below), at which point the CTA flips to "I've done this" so they
//   // can confirm + persist the carrier choice and move on.
//   const isMobilePhone = (() => {
//     if (typeof navigator === "undefined") return false;
//     const ua = navigator.userAgent || "";
//     // Phone-class UA patterns. Includes:
//     //   - iPhone/iPod (covers iOS Safari + iOS WKWebView in native apps)
//     //   - Android.*Mobile (Chrome on Android)
//     //   - Android.*wv (Android WebView used inside native/Capacitor/
//     //     Cordova/React-Native apps — earlier this was missing and
//     //     visitors inside webview shells fell through to the desktop
//     //     "I've done this" CTA)
//     //   - Mobi (generic token most Chromium-derived mobile browsers emit)
//     //   - BlackBerry / IEMobile / Opera Mini for the long tail
//     // Viewport width is intentionally NOT used as a signal — narrow
//     // desktop windows would false-positive into the dialer flow.
//     const phoneUA =
//       /iPhone|iPod|Android.*Mobile|Android.*wv|BlackBerry|IEMobile|Opera Mini|Mobi/i.test(
//         ua,
//       );
//     if (typeof window !== "undefined" && window.console) {
//       // Single-line debug — quick to grep when a real device shows the
//       // wrong CTA. Remove later once telemetry confirms parity.
//       console.log("[ForwardInstructions] mobile detect:", { ua, phoneUA });
//     }
//     return phoneUA;
//   })();
//   const [hasOpenedDialer, setHasOpenedDialer] = useState(false);
//   // Transient "opening dialer" state — between tap and the final
//   // "I've done this" CTA. Without it the button label flipped
//   // instantly which felt jarring (no acknowledgement of the click).
//   // 1.5s loader phase makes the transition feel intentional.
//   const [openingDialer, setOpeningDialer] = useState(false);
//   // "Did it work?" confirmation modal — shown after the user taps
//   // "Forward My Calls Now" (dialer opens, then on returning to the tab
//   // this asks them to confirm forwarding actually activated).
//   const [showDidItWork, setShowDidItWork] = useState(false);
//   // "Call forwarding Help" modal — shown when the user taps "No, it
//   // didn't" on the "Did it work?" prompt. Lists the common fixes and
//   // offers a "Submit Support Ticket" exit into the ticket flow.
//   const [showCallHelp, setShowCallHelp] = useState(false);
//   // "Forwarding calls to {agent}" reminder banner on the manual-steps
//   // (Step 2) view. Surfaced when the user taps "Show Me the Steps Again"
//   // from the failed test-call screen — it sits above the Direct Dial card
//   // with its own Try again / Get help actions.
//   //
//   // 🎨 DESIGN FLAG — set to `true` to force the banner visible on page load
//   // so it can be styled without going through the failed-test-call flow.
//   // Flip back to `false` to restore the normal trigger-based behaviour.
//   const [showForwardingBanner, setShowForwardingBanner] = useState(false);
//   // "Send a Test Call" modal — opened from "Yes, it did" (and the
//   // "Send a test call" link). Lets the user confirm/edit their own
//   // business number; tapping Call Now triggers an outbound test call
//   // (API wired separately) that should route through to the agent if
//   // forwarding is live.
//   const [showTestCall, setShowTestCall] = useState(false);
//   const [testCallNumber, setTestCallNumber] = useState("");
//   const [editingTestNumber, setEditingTestNumber] = useState(false);
//   // Flips to the "Connecting Call…" view inside the test-call modal once
//   // the user taps Call Now (while the outbound call is being placed).
//   const [callConnecting, setCallConnecting] = useState(false);
//   // Flips to the "You're live!" success view ~1s after connecting.
//   // const [callSuccess, setCallSuccess] = useState(false);
//   const [callSuccess, setCallSuccess] = useState(false);
//   // Flips to the "Almost there — forwarding isn't active yet" view.
//   const [callFailed, setCallFailed] = useState(false);
//   // Tracks the connecting→success timer so we can clear it if the user
//   // backs out of the modal before it resolves.
//   const callTimerRef = useRef(null);

//   // tel: link with the activation code. `#` MUST be %23-encoded or
//   // browsers truncate at the fragment separator and the dialer dials
//   // only the prefix. iOS + Android both accept `*` and `+` literally.
//   const dialerHref = (() => {
//     const code = (config.activate || "").replace("{number}", selectedNumber || "");
//     if (!code || !selectedNumber) return "";
//     return `tel:${code.replace(/#/g, "%23")}`;
//   })();

//   // "Do it now" handler — flip the CTA state IMMEDIATELY before
//   // navigating to the dialer, then open it. Earlier we waited for a
//   // `visibilitychange` event after the user returned from the dialer,
//   // but that event is unreliable across mobile browsers and webviews:
//   //   - Some webviews keep the tab "visible" because the dialer
//   //     opens as a chrome layer instead of backgrounding the page.
//   //   - Some browsers (older Android Chrome, certain in-app browsers)
//   //     don't fire visibilitychange on tel: navigations at all.
//   // Net effect was the button stayed "Do it now" forever and the
//   // wizard couldn't advance. Immediate flip gives us deterministic
//   // UX: tap → button instantly becomes "I've done this", dialer
//   // opens in parallel. When the user returns they see the next CTA.
//   // 1.5s loader phase between tap and the "I've done this" CTA.
//   // Sequence:
//   //   T+0ms    : tap → button shows spinner ("Opening dialer…")
//   //   T+0ms    : window.location navigates to tel: URI
//   //   T+1500ms : spinner clears → CTA flips to "I've done this"
//   // Even if the user is in the dialer when the timer fires (most
//   // common case), they return to the new label instead of seeing an
//   // abrupt mid-flight swap.
//   const DIALER_TRANSITION_MS = 1500;
//   // Unified primary-CTA handler. Shows the "Did it work?" confirmation
//   // IMMEDIATELY on click (don't defer into the timeout — a tel:
//   // navigation can suspend JS and swallow it). On a real phone we also
//   // open the native dialer pre-filled with the activation code; the
//   // popup is already up so it's there when the user returns.
//   const handleForwardNowClick = () => {
//     setShowDidItWork(true);
//     if (isMobilePhone && !hasOpenedDialer && dialerHref) {
//       setOpeningDialer(true);
//       window.location.href = dialerHref;
//       setTimeout(() => {
//         setOpeningDialer(false);
//         setHasOpenedDialer(true);
//       }, DIALER_TRANSITION_MS);
//     }
//   };

//   // Business owner's own phone number — the number we place the test
//   // call to. If forwarding is set up, that call rings through to the
//   // agent. Source from the business record, finally the decoded token.
//   const businessOwnerNumber =
//     agentCtx?.business?.phoneNumber ||
//     agentCtx?.business?.phone ||
//     decodeTokenData?.phone ||
//     decodeTokenData?.phoneNumber ||
//     "";

//   // Phone-input formatter — strips everything to digits (so letters can
//   // never land), caps at 15 digits (E.164 max), then re-groups into a
//   // dashed, country-coded format:
//   //   +1  → +1-XXX-XXX-XXXX   (US / Canada)
//   //   +91 → +91-XXXXX-XXXXX   (India)
//   // Until a recognised country code is typed it just shows the raw
//   // digits, so the user can start with "1" or "9".
//   const formatTestCallNumber = (raw) => {
//     const digits = (raw.match(/\d/g) || []).join("").slice(0, 15);
//     if (!digits) return "";

//     let cc = "";
//     let rest = digits;
//     if (digits.startsWith("91")) {
//       cc = "91";
//       rest = digits.slice(2);
//     } else if (digits.startsWith("1")) {
//       cc = "1";
//       rest = digits.slice(1);
//     }

//     if (!cc) return digits; // no country code yet → plain digits

//     // Group the national part per country code.
//     const groups = cc === "91" ? [5, 5] : [3, 3, 4];
//     const parts = [];
//     let i = 0;
//     for (const g of groups) {
//       if (i >= rest.length) break;
//       parts.push(rest.slice(i, i + g));
//       i += g;
//     }
//     // Any overflow digits (shouldn't happen within 15-cap) tack on.
//     if (i < rest.length) parts.push(rest.slice(i));

//     return parts.length ? `+${cc}-${parts.join("-")}` : `+${cc}`;
//   };

//   // Open the "Send a Test Call" modal — close the "Did it work?" popup
//   // and seed the number field with the owner's number (only if the user
//   // hasn't already edited it this session).
//   const openTestCall = () => {
//     setShowDidItWork(false);
//     setEditingTestNumber(false);
//     setCallConnecting(false);
//     setCallSuccess(false);
//     setCallFailed(false);
//     if (callTimerRef.current) clearTimeout(callTimerRef.current);
//     setTestCallNumber((prev) => prev || formatTestCallNumber(businessOwnerNumber));
//     setShowTestCall(true);
//   };

//   // National-part display (drops the "+1-" / "+91-" country prefix) for
//   // the "Connecting Call…" screen, matching the design.
//   const callDisplayNumber = testCallNumber.replace(/^\+\d{1,3}-/, "");

//   const closeTestCall = () => {
//     if (callTimerRef.current) clearTimeout(callTimerRef.current);
//     setShowTestCall(false);
//     setCallConnecting(false);
//     setCallSuccess(false);
//     setCallFailed(false);
//   };

//   // Back to the "Send a Test Call" form (from the failed screen) so the
//   // user can dial + retry.
//   const handleTestCallAgain = () => {
//     if (callTimerRef.current) clearTimeout(callTimerRef.current);
//     setCallConnecting(false);
//     setCallSuccess(false);
//     setCallFailed(false);
//   };

//   // "Get help" — reach support. Defaults to a mailto; rewire to your
//   // in-app help/chat if you have one.
//   const handleGetHelp = () => {
//     window.location.href =
//       "mailto:support@rxpt.us?subject=Call%20forwarding%20help";
//   };

//   // ── Failed test-call screen actions ──────────────────────────────
//   // "Test call again" (failed screen) / "Try again" (reminder banner) →
//   // re-place the test call DIRECTLY (skip the form) and surface the
//   // Connecting view. testCallNumber persists from the previous attempt;
//   // we seed it from the owner's number as a fallback so the call can
//   // still go out even if it was somehow cleared.
//   const handleRetryTestCall = () => {
//     setShowDidItWork(false);
//     setShowCallHelp(false);
//     setShowTestCall(true);
//     setTestCallNumber((prev) => prev || formatTestCallNumber(businessOwnerNumber));
//     handleCallNow();
//   };

//   // "Get help" (failed screen) → open the "Call forwarding Help" ticket
//   // popup instead of a mailto.
//   const handleFailedGetHelp = () => {
//     closeTestCall();
//     setShowCallHelp(true);
//   };

//   // "Show Me the Steps Again" → return to the manual-steps (Step 2) view
//   // and reveal the "Forwarding calls to {agent}" reminder banner.
//   const handleShowStepsAgain = () => {
//     closeTestCall();
//     setShowForwardingBanner(true);
//   };

//   // A number is "callable" only when it: starts with country code 1
//   // (US/Canada) or 91 (India), carries 7-15 digits, and isn't over the
//   // 15-digit E.164 ceiling.
//   const testCallDigitStr = (testCallNumber.match(/\d/g) || []).join("");
//   const startsWithAllowedCode =
//     testCallDigitStr.startsWith("1") || testCallDigitStr.startsWith("91");
//   const isTestCallValid =
//     startsWithAllowedCode &&
//     testCallDigitStr.length >= 7 &&
//     testCallDigitStr.length <= 15;

//   // "Call Now" — place the real outbound test call (agent Telnyx number →
//   // owner's number). The backend reports back whether the call forwarded
//   // to the agent (Retell answered) or never connected. We show the
//   // "Connecting…" view, then poll the status until it resolves.
//   const handleCallNow = async () => {
//     if (!isTestCallValid) return;
//     setCallConnecting(true);
//     setCallSuccess(false);
//     setCallFailed(false);
//     if (callTimerRef.current) clearTimeout(callTimerRef.current);

//     // UI-work mode — keep the "Connecting Call…" popup frozen on screen.
//     // Skip the API call + polling so it never advances. Set
//     // FREEZE_CONNECTING_POPUP = false to restore normal behaviour.
//     if (FREEZE_CONNECTING_POPUP) return;
//     console.log(selectedNumber, testCallNumber, "selectedNumber, testCallNumber")
//     try {
//       // `from` = agent's Telnyx number (the one owner forwards to); the
//       // backend may override this with a dedicated caller number via env.
//       const data = await startForwardingTestCall(selectedNumber, testCallNumber);
//       console.log(data, "data")
//       const testId = data?.testCallId;
//       if (!data?.success || !testId) {
//         setCallConnecting(false);
//         setCallFailed(true);
//         return;
//       }

//       const startedAt = Date.now();
//       const poll = async () => {
//         let status = "calling";
//         try {
//           const r = await getForwardingTestCallStatus(testId);
//           status = r?.status || "calling";
//         } catch {
//           /* transient — keep polling */
//         }

//         if (status === "forwarded") {
//           setCallConnecting(false);
//           setCallSuccess(true);
//           return;
//         }
//         if (status === "failed") {
//           setCallConnecting(false);
//           setCallFailed(true);
//           return;
//         }
//         // 'calling' / 'unknown' → keep polling until the 45s ceiling.
//         if (Date.now() - startedAt > 45000) {
//           setCallConnecting(false);
//           setCallFailed(true);
//           return;
//         }
//         callTimerRef.current = setTimeout(poll, 2000);
//       };
//       callTimerRef.current = setTimeout(poll, 2000);
//     } catch (err) {
//       console.error("[ForwardInstructions] test call failed:", err);
//       setCallConnecting(false);
//       setCallFailed(true);
//     }
//   };

//   // "Next: Set Up Call Triage" — success path. Forwarding is confirmed
//   // live (the test call routed to the agent), so run the normal done
//   // flow: persist the choice + advance the wizard to Call Triage.
//   const handleNextTriage = () => {
//     closeTestCall();
//     handleDone();
//   };

//   // Clear any pending connecting→success timer if the component unmounts.
//   useEffect(() => {
//     return () => {
//       if (callTimerRef.current) clearTimeout(callTimerRef.current);
//     };
//   }, []);

//   // "Yes, it did" — forwarding confirmed. Per updated flow we advance the
//   // user straight to the next onboarding step (Call Triage) instead of
//   // opening the test-call screen. handleDone persists the "carrier"
//   // choice and hands off to the wizard (onWizardDone → next step).
//   const handleDidItWorkYes = () => {
//     setShowDidItWork(false);
//     handleDone();
//   };

//   // "No, it didn't" — forwarding isn't active yet. Surface the "Call
//   // forwarding Help" screen with the common fixes + support-ticket exit.
//   const handleDidItWorkNo = () => {
//     setShowDidItWork(false);
//     setShowCallHelp(true);
//   };

//   // "Submit Support Ticket" — leave the wizard for the ticket flow.
//   // Stash a return descriptor so that once the ticket is raised the
//   // user is brought back to the wizard's NEXT step (Call Triage, internal
//   // step 4) rather than back onto the Forwarding step. See CreateTicket
//   // handleSubmit for the matching read of `ticketReturn`.
//   const handleSubmitSupportTicket = () => {
//     try {
//       sessionStorage.setItem(
//         "ticketReturn",
//         JSON.stringify({ path: "/go-live-setup", goLiveStep: 4 }),
//       );
//     } catch {
//       /* private mode / quota — ticket flow still works, just lands on list */
//     }
//     setShowCallHelp(false);
//     navigate("/raise-tickets");
//   };
//   // Inline copy feedback — appears directly under the copy icon for
//   // ~1.8s. Avoids relying solely on the global popup which is easy to
//   // miss on a crowded screen.
//   const [copiedFlash, setCopiedFlash] = useState(false);
//   const agentId = sessionStorage.getItem("SelectAgentId");
//   const agentBuisnesId = sessionStorage.getItem("SelectAgentBusinessId");

//   // ── Voip retention — 3-layered hydration ─────────────────────────
//   // Production bug spotted: user purchases a number on Step 4, leaves
//   // the wizard, comes back via URL (sessionStorage gone) → Step 7
//   // landed with an EMPTY phone number even though the agent's
//   // voip_numbers column was populated. Layered fallback below ensures
//   // the number is always rendered as long as ANY of these survive:
//   //
//   //   Layer 1: agentCtx prop (parent already has fresh DB data)
//   //   Layer 2: localStorage cache (survives browser close/reopen)
//   //   Layer 3: existing API fetch (deeper down in this file)
//   //
//   // All three are idempotent — first one to find a value wins, the
//   // rest skip via the `selectedNumber` guard.
//   // localStorage key is SCOPED by agentId so two tabs running the
//   // wizard for different agents don't read each other's voip cache.
//   // Earlier this was a single global key — tab A's voip would leak
//   // into tab B's UI even though B's agent was a different record.
//   // Returning "" when agentId is missing makes the key effectively
//   // a no-op (writes/reads silently skip).
//   const voipKeyFor = (id) => (id ? `postPurchase.voip.${id}` : "");

//   // Layer 1 — agentCtx from parent wizard (most up-to-date)
//   useEffect(() => {
//     if (selectedNumber) return;
//     const voip = agentCtx?.agent?.voip_numbers;
//     if (!voip) return;
//     try {
//       const parsed = typeof voip === "string" ? JSON.parse(voip) : voip;
//       const first = Array.isArray(parsed) ? parsed[0] : parsed;
//       if (first) {
//         setSelectedNumber(first);
//         // Mirror to localStorage so a subsequent browser-close visit
//         // can recover via Layer 2 even if agentCtx isn't ready yet.
//         try {
//           const k = voipKeyFor(agentId);
//           if (k) localStorage.setItem(k, first);
//         } catch { }
//       }
//     } catch {
//       /* malformed voip_numbers — fall through to other layers */
//     }
//   }, [agentCtx?.agent?.voip_numbers, selectedNumber]);

//   // Layer 2 — localStorage cache (browser close/reopen scenario)
//   useEffect(() => {
//     if (selectedNumber) return;
//     try {
//       const k = voipKeyFor(agentId);
//       const cached = k ? localStorage.getItem(k) : null;
//       if (cached) setSelectedNumber(cached);
//     } catch {
//       /* private mode / quota issues — silent fallback to Layer 3 */
//     }
//     // Run once on mount only — Layer 1 above re-fires on agentCtx
//     // changes, so we don't need this to react to anything.
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   // Generate step 1 text with actual number
//   const getActivateInstruction = () => {
//     if (!selectedNumber) return config.activate;
//     return config.activate.replace("{number}", selectedNumber);
//   };

//   // Copy number to clipboard
//   const handleCopyNumber = async () => {
//     if (!selectedNumber) {
//       setPopupType("warning");
//       setPopupMessage("No number to copy");
//       setShowPopup(true);
//       return;
//     }
//     try {
//       await navigator.clipboard.writeText(selectedNumber);
//       setCopiedFlash(true);
//       setTimeout(() => setCopiedFlash(false), 1800);
//     } catch (error) {
//       console.error("Failed to copy:", error);
//       setPopupType("error");
//       setPopupMessage("Failed to copy");
//       setShowPopup(true);
//     }
//   };

//   // Initial load - Extract from knowledge_base_texts if needed
//   useEffect(() => {
//     if (!agentId || !isInitialLoad.current) return;

//     const fetchAndSetBusinessDetails = async () => {
//       let agentDetails = null;
//       let businessDetails = null;

//       // First try to get from store
//       const res = getAgentById(agentId);

//       if (res?.agentData?.agent) {
//         agentDetails = res.agentData.agent;
//         businessDetails = res.agentData.business;
//         // Extract and set VOIP number if available
//         if (agentDetails.voip_numbers) {
//           try {
//             const voipNumbers = JSON.parse(agentDetails.voip_numbers);
//             if (voipNumbers && voipNumbers.length > 0) {
//               setSelectedNumber(voipNumbers[0]);
//             }
//           } catch (error) {
//             console.error("Error parsing voip_numbers:", error);
//           }
//         }
//       } else {
//         // If not in store, fetch from API
//         try {
//           const agentRequestDetails = {
//             agentId: agentId,
//             bussinesId: agentBuisnesId,
//           };

//           const response = await fetchAgentDetailById(agentRequestDetails);
//           const agentInfo = response?.data;

//           if (agentInfo) {
//             agentDetails = agentInfo.agent;
//             businessDetails = agentInfo.business;

//             // Save to store
//             let numbersArray = [];
//             let total = 0;
//             setAgentById(agentId, agentInfo, numbersArray, total);

//             // Extract and set VOIP number
//             if (agentInfo.voip_numbers) {
//               try {
//                 const voipNumbers = JSON.parse(agentInfo.voip_numbers);
//                 if (voipNumbers && voipNumbers.length > 0) {
//                   setSelectedNumber(voipNumbers[0]);
//                 }
//               } catch (error) {
//                 console.error("Error parsing voip_numbers:", error);
//               }
//             }
//           }
//         } catch (err) {
//           console.error("Failed to fetch data", err.response || err.message || err);
//           setPopupType("error");
//           setPopupMessage("Failed to load business details. Please try again.");
//           setShowPopup(true);
//           return;
//         }
//       }
//     };

//     fetchAndSetBusinessDetails();
//     isInitialLoad.current = false;
//   }, [agentId]);
//   // Persist which forwarding path the user picked so reporting /
//   // follow-up automations can branch on it. 'carrier' = user dialed the
//   // carrier activation code on their existing phone; 'direct' = user
//   // is giving the agent number out as their business line instead.
//   const persistForwardingChoice = async (choice) => {
//     if (!agentId) return;
//     try {
//       await updateAgent(agentId, {
//         forwardingType: choice,
//         forwardingCarrier: choice === "carrier" ? carrier || "" : "",
//       });
//     } catch (e) {
//       console.error("Failed to persist forwardingType:", e);
//     }
//   };

//   // Wizard fully complete on this step — drop the voip + carrier
//   // caches so a brand-new agent purchase later doesn't pre-fill with
//   // stale data from this run. Safe on both terminal paths
//   // (handleDone + handleUsingDirectly) — removeItem is a no-op on
//   // missing keys.
//   const clearVoipCache = () => {
//     try {
//       const vk = voipKeyFor(agentId);
//       if (vk) localStorage.removeItem(vk);
//       // Carrier cache uses the same agentId-scoping pattern. Clean it
//       // up alongside the voip cache so the next wizard run starts
//       // fresh — avoids "previous run's AT&T choice" leaking into a
//       // new agent's setup screen.
//       if (agentId) localStorage.removeItem(`postPurchase.carrier.${agentId}`);
//     } catch { }
//   };

//   const handleDone = async () => {
//     if (doneLoading) return;

//     setDoneLoading(true);
//     await persistForwardingChoice("carrier");
//     setDoneLoading(false);

//     clearVoipCache();
//     if (wizardMode && typeof onWizardDone === "function") {
//       onWizardDone("carrier");
//       return;
//     }
//     navigate("/fast-agent-detail", { replace: true });
//   };

//   // "I'm using the agent number directly" path — the user opts out of
//   // carrier-side forwarding entirely and will hand the agent number out
//   // as their business line.
//   const handleUsingDirectly = async () => {
//     if (doneLoading) return;
//     setDoneLoading(true);
//     await persistForwardingChoice("direct");
//     setDoneLoading(false);

//     clearVoipCache();
//     if (wizardMode && typeof onWizardDone === "function") {
//       onWizardDone("direct");
//       return;
//     }
//     navigate("/fast-agent-detail", { replace: true });
//   };

//   const handleEmailTheseSteps = async () => {
//     try {
//       const body = {
//         userId,                                    // token se decoded
//         carrier,                                   // sessionStorage "selectedCarrier"
//         aiPhoneNumber: selectedNumber,          // voip number (state)
//         forwardingCode: getActivateInstruction(), // e.g. **21*+19104063319#
//         stopForwardingCode: config.deactivate,
//       };

//       const response = await fetch(`${API_BASE_URL}/agent/send-forwarding-steps`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(body),
//       });

//       const data = await response.json();
//       if (data.success) {
//         setPopupType("success");
//         setPopupMessage("Steps sent to your email!");

//       } else {
//         setPopupType("error");
//         setPopupMessage(data.message || "Failed to send email.");
//       }
//       setShowPopup(true);
//     } catch (error) {
//       console.error("Email send error:", error);
//       setPopupType("error");
//       setPopupMessage("Something went wrong.");
//       setShowPopup(true);
//     }
//   };
//   const handleClosePopup = () => {
//     setShowPopup(false);
//   }
//   // const handleGoToDashboard = () => {
//   //    navigate("/fast-agent-detail");
//   // };
//   // const handleGoToDashboard = () => {
//   //   alert("ok")
//   //   for (let i = 0; i < window.history.length; i++) {
//   //     window.history.pushState(null, "", "/fast-agent-detail");
//   //   }
//   //   navigate("/fast-agent-detail", { replace: true });
//   //   // Step 3: Back button block
//   //   window.onpopstate = () => {
//   //     window.history.pushState(null, "", "/fast-agent-detail");
//   //   };
//   // };
//   const handleGoToDashboard = () => {
//     // History manipulation hata do — iPhone mein issue karta hai
//     navigate("/fast-agent-detail", { replace: true });
//   };
//   return (
//     <div
//       // In wizard mode the underlying CSS pins both `.bottombar` and
//       // `.looksGoodBtn` to `position: absolute; bottom: x%` which was
//       // sized for a single primary button on a full-screen page. Adding
//       // the "using directly" CTA overflows the viewport, so we let the
//       // whole container scroll and the absolute blocks sit in normal
//       // flow via an override class below. No change for the standalone
//       // route.
//       className={`${styles.containerBox}${wizardMode ? ` ${styles.containerBoxWizard}` : ""}`}
//     >
//       {doneLoading && (
//         <div className={styles.loadingOverlay}>
//           <Loader2 />
//         </div>
//       )}
//       <div className={styles.container}>
//         <div className={styles.titleBar}>
//           <h4 className={styles.lightTitle}>Manual steps for</h4>
//           <h5 className={styles.boldTitle}>call forwarding</h5>
//         </div>

//         {/* {carrier && (
//           <div className={styles.carrierInfo}>
//             <p className={styles.selectedCarrier}>
//               Instructions for: <strong>{carrier}</strong>
//             </p>
//           </div>
//         )} */}

//         <div className={styles.StepsMain}>
//           <div className={styles.stepWrapper}>
//             {/* Vertical Line */}
//             <div className={styles.line} />

//             {/* Step 1 */}
//             <div className={styles.stepRow}>
//               <div className={styles.stepCircle}>1</div>
//               <p className={styles.stepText}>
//                 Dial <strong>{getActivateInstruction()}</strong> from your{" "}
//                 <span className={styles.businessPhone}>business phone</span>
//               </p>
//             </div>

//             {/* Step 2 */}
//             <div className={styles.stepRow}>
//               <div className={styles.stepCircle}>2</div>
//               <div className={styles.stepContent}>
//                 <label className={styles.stepText}>Enter your AI phone number</label>
//                 <div className={styles.inputBox}>
//                   <input type="text" value={selectedNumber} readOnly />
//                   {/* Copy icon — no default "Copy" label. On click a
//                       transient "Copied" tooltip pops above the icon for
//                       ~1.8s (copiedFlash). */}
//                   <span className={styles.copyIcon} onClick={handleCopyNumber}>
//                     <img src="/svg/copy_icon_3.svg" alt="copy_icon_3" />
//                     {copiedFlash && (
//                       <span className={styles.copyTooltip}>Copied</span>
//                     )}
//                   </span>
//                 </div>
//               </div>
//             </div>

//             {/* Step 3 */}
//             <div className={styles.stepRow}>
//               <div className={styles.stepCircle}>3</div>
//               <p className={styles.stepText}>
//                 Wait for the <b>confirmation tone</b>
//               </p>
//             </div>
//           </div>
//         </div>

//         {/* Tip */}
//         {/* <div className={styles.TipDiv}>
//           <img src="/svg/tip_icon.svg" alt="tip_icon" />
//           <p className={styles.tipText}>
//             <span className={styles.TipTitle}>Tip:</span> You can stop forwarding
//             anytime by dialing <strong>{config.deactivate}</strong>
//           </p>
//         </div> */}
//         {showForwardingBanner && (
//           <div className={styles.fwdBanner}>
//             <div className={styles.fwdBannerTop}>
//               <span className={styles.fwdBannerIcon} aria-hidden="true">
//                 <svg width="59" height="59" viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg">
//                   <g filter="url(#filter0_d_15477_754)">
//                     <circle cx="29.5" cy="29.5" r="17.5" fill="white" />
//                   </g>
//                   <path d="M29.9996 21C25.0297 21 21 25.0297 21 29.9996C21 34.9695 25.0297 39 29.9996 39C34.9695 39 39 34.9695 39 29.9996C39 25.0297 34.9695 21 29.9996 21ZM31.8731 34.9482C31.4099 35.131 31.0411 35.2697 30.7646 35.3657C30.4543 35.467 30.1293 35.5157 29.803 35.5097C29.2423 35.5097 28.8057 35.3726 28.4949 35.099C28.184 34.8255 28.0293 34.4789 28.0293 34.0575C28.0293 33.8937 28.0408 33.7261 28.0636 33.5554C28.0919 33.361 28.1292 33.168 28.1756 32.9771L28.7554 30.9291C28.8065 30.7326 28.8507 30.5459 28.8857 30.3722C28.9208 30.197 28.9375 30.0362 28.9375 29.8899C28.9375 29.6293 28.8834 29.4465 28.776 29.3436C28.667 29.2408 28.4621 29.1905 28.1566 29.1905C28.0072 29.1905 27.8533 29.2126 27.6956 29.259C27.5394 29.307 27.4038 29.3505 27.2926 29.3931L27.4457 28.7623C27.8251 28.6076 28.1886 28.475 28.5352 28.3653C28.8522 28.2593 29.1838 28.2032 29.5181 28.1992C30.075 28.1992 30.5048 28.3349 30.8072 28.603C31.1082 28.872 31.2598 29.2217 31.2598 29.6514C31.2598 29.7406 31.2491 29.8975 31.2286 30.1215C31.2107 30.3308 31.1719 30.5378 31.1128 30.7394L30.536 32.7813C30.4843 32.966 30.4418 33.1532 30.4088 33.3421C30.3774 33.4993 30.3588 33.6588 30.3531 33.819C30.3531 34.0903 30.4133 34.2754 30.5352 34.3737C30.6556 34.472 30.8667 34.5215 31.1653 34.5215C31.3063 34.5215 31.464 34.4964 31.6423 34.4476C31.819 34.3989 31.947 34.3554 32.0278 34.3181L31.8731 34.9482ZM31.771 26.6602C31.5088 26.9075 31.16 27.0421 30.7996 27.035C30.4217 27.035 30.0956 26.9101 29.8244 26.6602C29.6954 26.5467 29.5924 26.4068 29.5223 26.25C29.4522 26.0931 29.4167 25.923 29.4183 25.7512C29.4183 25.397 29.5554 25.0922 29.8244 24.84C30.0872 24.5907 30.4375 24.4547 30.7996 24.4613C31.1783 24.4613 31.5029 24.587 31.771 24.84C32.04 25.0922 32.1749 25.397 32.1749 25.7512C32.1749 26.107 32.04 26.4103 31.771 26.6602Z" fill="#F29A3C" />
//                   <defs>
//                     <filter id="filter0_d_15477_754" x="0" y="0" width="59" height="59" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
//                       <feFlood flood-opacity="0" result="BackgroundImageFix" />
//                       <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
//                       <feOffset />
//                       <feGaussianBlur stdDeviation="6" />
//                       <feComposite in2="hardAlpha" operator="out" />
//                       <feColorMatrix type="matrix" values="0 0 0 0 0.92518 0 0 0 0 0.664128 0 0 0 0 0.38772 0 0 0 1 0" />
//                       <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_15477_754" />
//                       <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_15477_754" result="shape" />
//                     </filter>
//                   </defs>
//                 </svg>
//               </span>
//               <div className={styles.fwdBannerBody}>
//                 <p className={styles.fwdBannerTitle}>
//                   Forwarding calls to <strong>{agentName}</strong>
//                 </p>
//                 <p className={styles.fwdBannerText}>
//                   are <strong>very important</strong> for AI to answer your phone
//                 </p>
//               </div>
//             </div>

//             <div className={styles.fwdBannerActions}>
//               <button
//                 type="button"
//                 className={styles.fwdBannerTry}
//                 onClick={handleRetryTestCall}
//               >
//                 Try again
//               </button>
//               <span className={styles.fwdBannerSep} />
//               <button
//                 type="button"
//                 className={styles.fwdBannerHelp}
//                 onClick={() => setShowCallHelp(true)}
//               >
//                 Get help →
//               </button>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* "Forwarding calls to {agent}" reminder banner — revealed when the
//           user returns here via "Show Me the Steps Again" on the failed
//           test-call screen. Carries its own Try again / Get help actions. */}


//       {/* ── New "Direct Dial from this phone" card (design spec) ── */}
//       <div className={styles.directDialCard}>
//         <div className={styles.directDialHeader}>
//           <h4 className={styles.directDialTitle}>
//             Direct Dial <strong>from this phone</strong>
//           </h4>
//         </div>

//         <div className={styles.directDialBody}>
//           <p className={styles.directDialDesc}>
//             Tap below to open your dialer with the forwarding code ready.
//           </p>

//           {/* On mobile the primary CTA opens the native dialer pre-filled
//               with the activation code, then flips to "I've done this" so the
//               user can confirm + advance. Desktop / tablet go straight to the
//               confirm button — tel: links there open Skype/Teams which is a
//               broken UX for carrier USSD codes. */}
//           <AnimatedButton
//             label={
//               <span className={styles.forwardBtnLabel}>
//                 <span className={styles.forwardBtnTitle}>Forward My Calls Now</span>
//                 <span className={styles.forwardBtnSub}>
//                   Opens your phone dialer with the code ready
//                 </span>
//               </span>
//             }
//             isLoading={openingDialer}
//             onClick={handleForwardNowClick}
//             disabled={openingDialer || doneLoading}
//             positionType="relative"
//             width="100%"
//             bottom="0px"
//           />

//           <p className={styles.quickHassle}>Quick, Hassle Free</p>
//         </div>

//         {/* Alternative path — visitor hands out the agent number as their
//             business line instead of forwarding their existing carrier
//             number. Both CTAs persist the choice via persistForwardingChoice
//             so reporting can distinguish the two. */}
//         {/* {wizardMode && !hideDirectPublishCta && (
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "column",
//               alignItems: "center",
//               gap: 4,
//               marginTop: 18,
//             }}
//           >
//             <span
//               style={{
//                 fontSize: 13,
//                 color: "#1f2937",
//                 fontWeight: 500,
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: 6,
//               }}
//             >
//               I will publish
//               <span
//                 aria-hidden="true"
//                 style={{
//                   width: 16,
//                   height: 16,
//                   borderRadius: "50%",
//                   background: "#16A34A",
//                   display: "inline-flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                 }}
//               >
//                 <svg width="9" height="9" viewBox="0 0 16 16" fill="none">
//                   <path
//                     d="M3.5 8L6.5 11L12.5 5"
//                     stroke="#fff"
//                     strokeWidth="2.4"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                 </svg>
//               </span>
//               {agentName}'s number directly
//             </span>
//             <button
//               type="button"
//               onClick={handleUsingDirectly}
//               disabled={doneLoading || !selectedNumber}
//               style={{
//                 background: "transparent",
//                 border: "none",
//                 padding: "4px 8px",
//                 fontSize: 14,
//                 fontWeight: 700,
//                 color: "#1f2937",
//                 textDecoration: "underline",
//                 textUnderlineOffset: 3,
//                 cursor:
//                   doneLoading || !selectedNumber ? "not-allowed" : "pointer",
//                 opacity: doneLoading || !selectedNumber ? 0.6 : 1,
//                 display: "inline-flex",
//                 alignItems: "center",
//                 gap: 0,
//               }}
//             >
//               Skip this step
//               <span aria-hidden="true">→</span>
//             </button>
//           </div>
//         )} */}
//       </div>

//       {/* ════════ OLD bottom CTA block — disabled (kept for reference,
//           replaced by the Direct Dial card above). Not deleted on request. ════════ */}
//       {false && (
//         <>
//           {!wizardMode && (
//             <div
//               className={styles.bottombar}
//               // Default CSS pins this at bottom: 13% absolute, which hides the
//               // block behind the wizard header/scroll. In wizardMode we switch
//               // to normal flow so it sits under the tip above the CTAs.
//               style={wizardMode ? { position: "static", transform: "none", marginTop: 20, paddingInline: 0 } : undefined}
//             >
//               <p className={styles.desc} onClick={handleEmailTheseSteps}>Email me these steps</p>
//               <div className={styles.divider}></div>
//             </div>
//           )}

//           <div
//             className={styles.looksGoodBtn}
//             style={wizardMode ? { position: "fixed", bottom: "calc(10px + var(--wizard-cta-lift, 0px))", left: "50%", transform: "translateX(-50%)", width: "calc(100% - 32px)", maxWidth: "468px", zIndex: 60 } : undefined}
//           >
//             {isMobilePhone && !hasOpenedDialer ? (
//               <AnimatedButton
//                 label={openingDialer ? "Opening dialer…" : "Do it now"}
//                 isLoading={openingDialer}
//                 onClick={handleForwardNowClick}
//                 disabled={!dialerHref || openingDialer}
//                 positionType={wizardMode ? "relative" : undefined}
//               />
//             ) : (
//               <AnimatedButton
//                 label="I've done this"
//                 onClick={handleDone}
//                 positionType={wizardMode ? "relative" : undefined}
//               />
//             )}

//             {wizardMode && !hideDirectPublishCta && (
//               <div
//                 style={{
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "center",
//                   gap: 4,
//                 }}
//               >
//                 <span
//                   style={{
//                     fontSize: 13,
//                     color: "#1f2937",
//                     fontWeight: 500,
//                     display: "inline-flex",
//                     alignItems: "center",
//                     gap: 6,
//                   }}
//                 >
//                   I will publish
//                   <span
//                     aria-hidden="true"
//                     style={{
//                       width: 16,
//                       height: 16,
//                       borderRadius: "50%",
//                       background: "#16A34A",
//                       display: "inline-flex",
//                       alignItems: "center",
//                       justifyContent: "center",
//                     }}
//                   >
//                     <svg width="9" height="9" viewBox="0 0 16 16" fill="none">
//                       <path
//                         d="M3.5 8L6.5 11L12.5 5"
//                         stroke="#fff"
//                         strokeWidth="2.4"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       />
//                     </svg>
//                   </span>
//                   {agentName}'s number directly
//                 </span>
//                 <button
//                   type="button"
//                   onClick={handleUsingDirectly}
//                   disabled={doneLoading || !selectedNumber}
//                   style={{
//                     background: "transparent",
//                     border: "none",
//                     padding: "4px 8px",
//                     fontSize: 14,
//                     fontWeight: 700,
//                     color: "#1f2937",
//                     textDecoration: "underline",
//                     textUnderlineOffset: 3,
//                     cursor:
//                       doneLoading || !selectedNumber ? "not-allowed" : "pointer",
//                     opacity: doneLoading || !selectedNumber ? 0.6 : 1,
//                     display: "inline-flex",
//                     alignItems: "center",
//                     gap: 0,
//                   }}
//                 >
//                   Skip this step
//                   <span aria-hidden="true">→</span>
//                 </button>
//               </div>
//             )}
//           </div>
//         </>
//       )}
//       {/* Back button is owned by the wizard footer (PostPurchaseSetup)
//           so we don't render one here anymore — the previous bottom Back
//           was creating a duplicate. */}

//       {/* Popup for copy feedback */}
//       {showPopup && (
//         <PopUp
//           type={popupType}
//           onClose={() => handleClosePopup()}
//           message={popupMessage}

//         />
//       )}

//       {/* "Did it work?" confirmation — reuses the shared <Modal/> shell.
//           Shown after the user taps "Forward My Calls Now" so they can
//           confirm forwarding actually activated (or run a test call). */}
//       <Modal isOpen={showDidItWork} onClose={() => setShowDidItWork(false)} showNotch={false} showClose={false}>
//         <div className={styles.didItWork}>
//           <h3 className={styles.didItWorkTitle}>Did it work?</h3>
//           <div className={styles.didItWorkDivider} />
//           <p className={styles.didItWorkText}>
//             <strong>Call forwarding</strong> is what will make your agent{" "}
//             <strong>Active </strong>If it did not work, your agent will be dormant.
//           </p>
//           <p className={styles.didItWorkSub}>

//           </p>
//           <p className={styles.didItWorkConfirm}>
//             Please confirm your call forwarding is working.
//           </p>

//           <div className={styles.didItWorkBtns}>
//             <button
//               type="button"
//               className={styles.didItWorkNo}
//               onClick={handleDidItWorkNo}
//             >
//               No, it didn't
//             </button>
//             <button
//               type="button"
//               className={styles.didItWorkYes}
//               onClick={handleDidItWorkYes}
//               disabled={doneLoading}
//             >
//               Yes, it did
//             </button>
//           </div>

//           <button
//             type="button"
//             className={styles.testCallLink}
//             onClick={openTestCall}
//           >
//             <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//               <path d="M14.6268 5.20487C15.6555 5.40519 16.601 5.90735 17.3421 6.64707C18.0833 7.38679 18.5864 8.33042 18.7871 9.35718M14.6268 1C16.7641 1.23698 18.7572 2.19226 20.2787 3.709C21.8003 5.22573 22.7599 7.21376 23 9.34667M21.9468 17.7354V20.889C21.948 21.1818 21.8879 21.4716 21.7704 21.7398C21.6529 22.0081 21.4805 22.2489 21.2644 22.4468C21.0482 22.6447 20.793 22.7954 20.5152 22.8892C20.2373 22.983 19.9429 23.0178 19.6507 22.9915C16.4098 22.64 13.2966 21.5346 10.5613 19.7642C8.01656 18.1503 5.85903 15.9968 4.24197 13.4569C2.46198 10.7145 1.35426 7.59218 1.00855 4.34287C0.982229 4.05217 1.01684 3.75919 1.11019 3.48258C1.20353 3.20597 1.35356 2.95178 1.55072 2.73621C1.74788 2.52064 1.98785 2.34841 2.25535 2.23047C2.52286 2.11254 2.81204 2.05149 3.10448 2.05122H6.26417C6.77531 2.0462 7.27084 2.22685 7.6584 2.55952C8.04595 2.89218 8.29909 3.35415 8.37063 3.85931C8.50399 4.86855 8.75132 5.85949 9.10789 6.81323C9.2496 7.18949 9.28027 7.5984 9.19626 7.99152C9.11226 8.38464 8.91711 8.74549 8.63394 9.0313L7.29633 10.3663C8.79567 12.9981 10.9789 15.1772 13.6157 16.6737L14.9533 15.3386C15.2397 15.056 15.6012 14.8612 15.9951 14.7774C16.389 14.6935 16.7987 14.7241 17.1756 14.8656C18.1312 15.2214 19.124 15.4683 20.1352 15.6014C20.6468 15.6734 21.1141 15.9307 21.4481 16.3241C21.7821 16.7176 21.9596 17.2198 21.9468 17.7354Z" fill="white" />
//               <path d="M14.6268 5.20487C15.6555 5.40519 16.601 5.90735 17.3421 6.64707C18.0833 7.38679 18.5864 8.33042 18.7871 9.35718M14.6268 1C16.7641 1.23698 18.7572 2.19226 20.2787 3.709C21.8003 5.22573 22.7599 7.21376 23 9.34667M21.9468 17.7354V20.889C21.948 21.1818 21.8879 21.4716 21.7704 21.7398C21.6529 22.0081 21.4805 22.2489 21.2644 22.4468C21.0482 22.6447 20.793 22.7954 20.5152 22.8892C20.2373 22.983 19.9429 23.0178 19.6507 22.9915C16.4098 22.64 13.2966 21.5346 10.5613 19.7642C8.01656 18.1503 5.85903 15.9968 4.24197 13.4569C2.46198 10.7145 1.35426 7.59218 1.00855 4.34287C0.982229 4.05217 1.01684 3.75919 1.11019 3.48258C1.20353 3.20597 1.35356 2.95178 1.55072 2.73621C1.74788 2.52064 1.98785 2.34841 2.25535 2.23047C2.52286 2.11254 2.81204 2.05149 3.10448 2.05122H6.26417C6.77531 2.0462 7.27084 2.22685 7.6584 2.55952C8.04595 2.89218 8.29909 3.35415 8.37063 3.85931C8.50399 4.86855 8.75132 5.85949 9.10789 6.81323C9.2496 7.18949 9.28027 7.5984 9.19626 7.99152C9.11226 8.38464 8.91711 8.74549 8.63394 9.0313L7.29633 10.3663C8.79567 12.9981 10.9789 15.1772 13.6157 16.6737L14.9533 15.3386C15.2397 15.056 15.6012 14.8612 15.9951 14.7774C16.389 14.6935 16.7987 14.7241 17.1756 14.8656C18.1312 15.2214 19.124 15.4683 20.1352 15.6014C20.6468 15.6734 21.1141 15.9307 21.4481 16.3241C21.7821 16.7176 21.9596 17.2198 21.9468 17.7354Z" stroke="#00C524" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
//             </svg>
//             Not sure? Send a test call →
//           </button>
//         </div>
//       </Modal>

//       {/* "Call forwarding Help" — shown when the user taps "No, it didn't"
//           on the "Did it work?" prompt. Lists the common 30-second fixes and
//           a "Submit Support Ticket" exit into the ticket flow. */}
//       <Modal
//         isOpen={showCallHelp}
//         onClose={() => setShowCallHelp(false)}
//         showNotch={false}
//         showClose={true}
//       >
//         <div className={styles.callHelp}>
//           <h3 className={styles.callHelpTitle}>Call forwarding Help</h3>
//           <p className={styles.callHelpSubtitle}>
//             This step is crucial for AI implementation
//           </p>

//           <p className={styles.callHelpText}>
//             <strong>{agentName}</strong> stays dormant until she is able to
//             answer your business calls.
//           </p>
//           <p className={styles.callHelpHint}>It's usually a 30-second fix.</p>

//           <div className={styles.callHelpFixes}>
//             <p className={styles.callHelpFixesTitle}>Common fixes:</p>

//             <div className={styles.callHelpFixesList}>
//               {[
//                 <>
//                   Dial <strong>{getActivateInstruction()}</strong> from your
//                   business phone{" "}
//                   <span className={styles.callHelpMuted}>(not this one)</span> and
//                   wait for the confirmation tone
//                 </>,
//                 <>Make sure you picked the right carrier.</>,
//                 <>Verify the full 10-digit target number.</>,
//                 <>Restart the mobile device completely.</>,
//                 <>Disable Wi-Fi Calling in Settings.</>,
//                 <>Turn off iPhone Live Voicemail.</>,
//                 <> Reset network settings on the device.</>,
//                 <>Test the VoIP number directly first.</>,
//                 <> Update the phone operating system software.</>,
//                 <>Contact the cellular carrier for provisioning.</>,

//               ].map((fix, i) => (
//                 <div className={styles.callHelpFixRow} key={i}>
//                   <span className={styles.callHelpFixIcon} aria-hidden="true">
//                     <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
//                       <circle cx="12" cy="12" r="10" stroke="#24252C" strokeWidth="1.5" />
//                       <path
//                         d="M8 12h7M12 9l3 3-3 3"
//                         stroke="#24252C"
//                         strokeWidth="1.6"
//                         strokeLinecap="round"
//                         strokeLinejoin="round"
//                       />
//                     </svg>
//                   </span>
//                   <p className={styles.callHelpFixText}>{fix}</p>
//                 </div>
//               ))}
//             </div>
//           </div>

//           <AnimatedButton
//             label="Submit Support Ticket →"
//             onClick={handleSubmitSupportTicket}
//             positionType="relative"
//             width="100%"
//             bottom="-10px"
//           />
//         </div>
//       </Modal>

//       {/* "Send a Test Call" — opened from "Yes, it did" / the test-call
//           link. Calls the owner's own business number; a live forward
//           routes it to the agent. Reuses the shared <Modal/> shell. */}
//       <Modal isOpen={showTestCall} onClose={closeTestCall} showNotch={false} showClose={false}>
//         {callFailed ? (
//           // <div className={styles.almost}>
//           //   <h3 className={styles.almostTitle}>Almost there</h3>
//           //   <p className={styles.almostSubtitle}>forwarding isn't active yet</p>

//           //   <p className={styles.almostText}>
//           //     <strong>{agentName}</strong> didn't pick up, so your calls aren't
//           //     reaching her yet. Your agent stays dormant until this works.
//           //   </p>
//           //   <p className={styles.almostHint}>It's usually a 30-second fix.</p>

//           //   <div className={styles.almostFixes}>
//           //     <p className={styles.almostFixesTitle}>Common fixes:</p>
//           //     <div className={styles.almostFixRow}>
//           //       <span className={styles.almostFixIcon}>
//           //         <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
//           //           <circle cx="12" cy="12" r="9" stroke="#24252C" strokeWidth="1.6" />
//           //           <path d="M9.5 12h5M12.5 9.5l2.5 2.5-2.5 2.5" stroke="#24252C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
//           //         </svg>
//           //       </span>
//           //       <p className={styles.almostFixText}>
//           //         Dial <strong>{getActivateInstruction()}</strong> from your
//           //         business phone <span className={styles.almostMuted}>(not this one)</span> and
//           //         wait for the confirmation tone
//           //       </p>
//           //     </div>
//           //     <div className={styles.almostFixRow}>
//           //       <span className={styles.almostFixIcon}>
//           //         <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
//           //           <circle cx="12" cy="12" r="9" stroke="#24252C" strokeWidth="1.6" />
//           //           <path d="M9.5 12h5M12.5 9.5l2.5 2.5-2.5 2.5" stroke="#24252C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
//           //         </svg>
//           //       </span>
//           //       <p className={styles.almostFixText}>
//           //         Make sure you picked the right carrier
//           //       </p>
//           //     </div>
//           //   </div>

//           //   <div className={styles.almostNextBtnWrap}>
//           //     <AnimatedButton
//           //       label="Show Me the Steps Again →"
//           //       onClick={closeTestCall}
//           //       positionType="relative"
//           //       width="100%"
//           //       bottom="0px"
//           //     />
//           //   </div>

//           //   <div className={styles.almostActions}>
//           //     <button
//           //       type="button"
//           //       className={styles.almostActionBtn}
//           //       onClick={handleTestCallAgain}
//           //     >
//           //       <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//           //         <path d="M14.6268 5.20487C15.6555 5.40519 16.601 5.90735 17.3421 6.64707C18.0833 7.38679 18.5864 8.33042 18.7871 9.35718M14.6268 1C16.7641 1.23698 18.7572 2.19226 20.2787 3.709C21.8003 5.22573 22.7599 7.21376 23 9.34667M21.9468 17.7354V20.889C21.948 21.1818 21.8879 21.4716 21.7704 21.7398C21.6529 22.0081 21.4805 22.2489 21.2644 22.4468C21.0482 22.6447 20.793 22.7954 20.5152 22.8892C20.2373 22.983 19.9429 23.0178 19.6507 22.9915C16.4098 22.64 13.2966 21.5346 10.5613 19.7642C8.01656 18.1503 5.85903 15.9968 4.24197 13.4569C2.46198 10.7145 1.35426 7.59218 1.00855 4.34287C0.982229 4.05217 1.01684 3.75919 1.11019 3.48258C1.20353 3.20597 1.35356 2.95178 1.55072 2.73621C1.74788 2.52064 1.98785 2.34841 2.25535 2.23047C2.52286 2.11254 2.81204 2.05149 3.10448 2.05122H6.26417C6.77531 2.0462 7.27084 2.22685 7.6584 2.55952C8.04595 2.89218 8.29909 3.35415 8.37063 3.85931C8.50399 4.86855 8.75132 5.85949 9.10789 6.81323C9.2496 7.18949 9.28027 7.5984 9.19626 7.99152C9.11226 8.38464 8.91711 8.74549 8.63394 9.0313L7.29633 10.3663C8.79567 12.9981 10.9789 15.1772 13.6157 16.6737L14.9533 15.3386C15.2397 15.056 15.6012 14.8612 15.9951 14.7774C16.389 14.6935 16.7987 14.7241 17.1756 14.8656C18.1312 15.2214 19.124 15.4683 20.1352 15.6014C20.6468 15.6734 21.1141 15.9307 21.4481 16.3241C21.7821 16.7176 21.9596 17.2198 21.9468 17.7354Z" fill="white" />
//           //         <path d="M14.6268 5.20487C15.6555 5.40519 16.601 5.90735 17.3421 6.64707C18.0833 7.38679 18.5864 8.33042 18.7871 9.35718M14.6268 1C16.7641 1.23698 18.7572 2.19226 20.2787 3.709C21.8003 5.22573 22.7599 7.21376 23 9.34667M21.9468 17.7354V20.889C21.948 21.1818 21.8879 21.4716 21.7704 21.7398C21.6529 22.0081 21.4805 22.2489 21.2644 22.4468C21.0482 22.6447 20.793 22.7954 20.5152 22.8892C20.2373 22.983 19.9429 23.0178 19.6507 22.9915C16.4098 22.64 13.2966 21.5346 10.5613 19.7642C8.01656 18.1503 5.85903 15.9968 4.24197 13.4569C2.46198 10.7145 1.35426 7.59218 1.00855 4.34287C0.982229 4.05217 1.01684 3.75919 1.11019 3.48258C1.20353 3.20597 1.35356 2.95178 1.55072 2.73621C1.74788 2.52064 1.98785 2.34841 2.25535 2.23047C2.52286 2.11254 2.81204 2.05149 3.10448 2.05122H6.26417C6.77531 2.0462 7.27084 2.22685 7.6584 2.55952C8.04595 2.89218 8.29909 3.35415 8.37063 3.85931C8.50399 4.86855 8.75132 5.85949 9.10789 6.81323C9.2496 7.18949 9.28027 7.5984 9.19626 7.99152C9.11226 8.38464 8.91711 8.74549 8.63394 9.0313L7.29633 10.3663C8.79567 12.9981 10.9789 15.1772 13.6157 16.6737L14.9533 15.3386C15.2397 15.056 15.6012 14.8612 15.9951 14.7774C16.389 14.6935 16.7987 14.7241 17.1756 14.8656C18.1312 15.2214 19.124 15.4683 20.1352 15.6014C20.6468 15.6734 21.1141 15.9307 21.4481 16.3241C21.7821 16.7176 21.9596 17.2198 21.9468 17.7354Z" stroke="#24252c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
//           //       </svg>
//           //       Test call again
//           //     </button>
//           //     <span className={styles.almostDivider} />
//           //     <button
//           //       type="button"
//           //       className={styles.almostActionBtn}
//           //       onClick={handleGetHelp}
//           //     >
//           //       Get help →
//           //     </button>
//           //   </div>
//           // </div>
//           <div className={styles.almost}>
//             <h3 className={styles.almostTitle}>Almost there</h3>
//             <p className={styles.almostSubtitle}>forwarding isn't active yet</p>

//             <p className={styles.almostText}>
//               <strong>{agentName}</strong> didn't pick up, so your calls aren't
//               reaching her yet. Your agent stays dormant until this works.
//             </p>
//             <p className={styles.almostHint}>It's usually a 30-second fix.</p>

//             <div className={styles.almostFixes}>
//               <p className={styles.almostFixesTitle}>Common fixes:</p>
//               <div className={styles.almostFixRow}>
//                 <span className={styles.almostFixIcon}>
//                   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
//                     <circle cx="12" cy="12" r="9" stroke="#24252C" strokeWidth="1.6" />
//                     <path d="M9.5 12h5M12.5 9.5l2.5 2.5-2.5 2.5" stroke="#24252C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
//                   </svg>
//                 </span>
//                 <p className={styles.almostFixText}>
//                   Dial <strong>{getActivateInstruction()}</strong> from your
//                   business phone <span className={styles.almostMuted}>(not this one)</span> and
//                   wait for the confirmation tone
//                 </p>
//               </div>
//               <div className={styles.almostFixRow}>
//                 <span className={styles.almostFixIcon}>
//                   <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
//                     <circle cx="12" cy="12" r="9" stroke="#24252C" strokeWidth="1.6" />
//                     <path d="M9.5 12h5M12.5 9.5l2.5 2.5-2.5 2.5" stroke="#24252C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
//                   </svg>
//                 </span>
//                 <p className={styles.almostFixText}>
//                   Make sure you picked the right carrier
//                 </p>
//               </div>
//             </div>

//             <div className={styles.almostNextBtnWrap}>
//               <AnimatedButton
//                 label="Show Me the Steps Again →"
//                 onClick={handleShowStepsAgain}
//                 positionType="relative"
//                 width="100%"
//                 bottom="0px"
//               />
//             </div>

//             <div className={styles.almostActions}>
//               <button
//                 type="button"
//                 className={styles.almostActionBtn}
//                 onClick={handleRetryTestCall}
//               >
//                 <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
//                   <path d="M14.6268 5.20487C15.6555 5.40519 16.601 5.90735 17.3421 6.64707C18.0833 7.38679 18.5864 8.33042 18.7871 9.35718M14.6268 1C16.7641 1.23698 18.7572 2.19226 20.2787 3.709C21.8003 5.22573 22.7599 7.21376 23 9.34667M21.9468 17.7354V20.889C21.948 21.1818 21.8879 21.4716 21.7704 21.7398C21.6529 22.0081 21.4805 22.2489 21.2644 22.4468C21.0482 22.6447 20.793 22.7954 20.5152 22.8892C20.2373 22.983 19.9429 23.0178 19.6507 22.9915C16.4098 22.64 13.2966 21.5346 10.5613 19.7642C8.01656 18.1503 5.85903 15.9968 4.24197 13.4569C2.46198 10.7145 1.35426 7.59218 1.00855 4.34287C0.982229 4.05217 1.01684 3.75919 1.11019 3.48258C1.20353 3.20597 1.35356 2.95178 1.55072 2.73621C1.74788 2.52064 1.98785 2.34841 2.25535 2.23047C2.52286 2.11254 2.81204 2.05149 3.10448 2.05122H6.26417C6.77531 2.0462 7.27084 2.22685 7.6584 2.55952C8.04595 2.89218 8.29909 3.35415 8.37063 3.85931C8.50399 4.86855 8.75132 5.85949 9.10789 6.81323C9.2496 7.18949 9.28027 7.5984 9.19626 7.99152C9.11226 8.38464 8.91711 8.74549 8.63394 9.0313L7.29633 10.3663C8.79567 12.9981 10.9789 15.1772 13.6157 16.6737L14.9533 15.3386C15.2397 15.056 15.6012 14.8612 15.9951 14.7774C16.389 14.6935 16.7987 14.7241 17.1756 14.8656C18.1312 15.2214 19.124 15.4683 20.1352 15.6014C20.6468 15.6734 21.1141 15.9307 21.4481 16.3241C21.7821 16.7176 21.9596 17.2198 21.9468 17.7354Z" stroke="#24252c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
//                 </svg>
//                 Test call again
//               </button>
//               <span className={styles.almostDivider} />
//               <button
//                 type="button"
//                 className={styles.almostActionBtn}
//                 onClick={handleFailedGetHelp}
//               >
//                 Get help →
//               </button>
//             </div>
//           </div>
//         ) : callSuccess ? (
//           <div className={styles.liveSuccess}>
//             <div className={styles.liveHeader}>
//               <span className={styles.liveCheck}>
//                 <svg width="18" height="18" viewBox="0 0 16 16" fill="none" aria-hidden="true">
//                   <path
//                     d="M3.5 8L6.5 11L12.5 5"
//                     stroke="#fff"
//                     strokeWidth="2.4"
//                     strokeLinecap="round"
//                     strokeLinejoin="round"
//                   />
//                 </svg>
//               </span>
//               <h3 className={styles.liveTitle}>You're live!</h3>
//             </div>

//             <p className={styles.liveText}>
//               <strong>{agentName}</strong> just answered on your business line.
//               Call forwarding is working perfectly.
//             </p>
//             <p className={styles.liveSubText}>
//               From now on she's catching your calls 24/7, even when you can't
//               pick up.
//             </p>

//             <AnimatedButton
//               label="Next: Set Up Call Triage →"
//               onClick={handleNextTriage}
//               disabled={doneLoading}
//               positionType="relative"
//               width="100%"
//               bottom="0px"
//             />

//             <p className={styles.liveFootnote}>
//               Your agent is now Active on your business phone
//             </p>
//           </div>
//         ) : callConnecting ? (
//           <div className={styles.connecting}>
//             <h3 className={styles.connectingTitle}>Connecting Call...</h3>
//             <p className={styles.connectingSub}>
//               Checking if <strong>"{agentName}"</strong> answers your business
//               phone.
//             </p>

//             <div className={styles.testCallDashDivider} />

//             <div className={styles.connectingRow}>
//               <div className={styles.connectingAvatar}>
//                 <img src="/svg/fav_icon.svg" alt="" />
//               </div>

//               <div className={styles.connectingMid}>
//                 <div className={styles.connectingWaitLine}>
//                   <span className={styles.connectingWait}>PLEASE WAIT...</span>
//                   <span className={styles.connectingArrows}>
//                     <svg width="40" height="16" viewBox="0 0 40 16" fill="none" aria-hidden="true">
//                       <path d="M4 3l5 5-5 5M15 3l5 5-5 5M26 3l5 5-5 5" stroke="#3DC55B" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
//                     </svg>
//                   </span>
//                 </div>
//                 <span className={styles.connectingCalling}>
//                   calling your number now.
//                 </span>
//                 <span className={styles.connectingNumber}>{callDisplayNumber}</span>
//               </div>

//               <div className={styles.connectingPhone}>
//                 <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
//                   <path
//                     d="M6.8 3.2h2.3l1.25 3.3-1.7 1.25a11 11 0 0 0 4.4 4.4l1.25-1.7 3.3 1.25v2.3a1.8 1.8 0 0 1-1.95 1.8A14.5 14.5 0 0 1 5 5.15 1.8 1.8 0 0 1 6.8 3.2z"
//                     stroke="#16A34A"
//                     strokeWidth="1.7"
//                     strokeLinejoin="round"
//                   />
//                   <path d="M15.5 4.5a4 4 0 0 1 3.5 3.5M15.5 1.6a7 7 0 0 1 6.4 6.4" stroke="#16A34A" strokeWidth="1.7" strokeLinecap="round" />
//                 </svg>
//               </div>
//             </div>

//             <span className={styles.connectingNumber}>{callDisplayNumber}</span>

//             <button
//               type="button"
//               className={styles.goBackLink}
//               onClick={closeTestCall}
//             >
//               &lt;&lt;&lt; Go Back to Call Forwarding
//             </button>
//           </div>
//         ) : (
//           <div className={styles.testCall}>
//             <h3 className={styles.testCallTitle}>Send a Test Call</h3>
//             <p className={styles.testCallText}>
//               We'll call your <strong>business number</strong>
//             </p>
//             <p className={styles.testCallSub}>
//               If forwarding is set up, <strong>{agentName}</strong> will answers it.
//             </p>

//             <div className={styles.testCallDashDivider} />

//             <div className={styles.testCallNumberRow}>
//               {editingTestNumber ? (
//                 <input
//                   type="tel"
//                   inputMode="tel"
//                   className={styles.testCallInput}
//                   value={testCallNumber}
//                   onChange={(e) => setTestCallNumber(formatTestCallNumber(e.target.value))}
//                   onKeyPress={(e) => {
//                     // Block letters/symbols at the keystroke level too, so
//                     // nothing flashes in before the sanitiser runs.
//                     if (!/[\d+\s()-]/.test(e.key)) e.preventDefault();
//                   }}
//                   onBlur={() => setEditingTestNumber(false)}
//                   placeholder="+1 000-000-0000"
//                   maxLength={20}
//                   autoFocus
//                 />
//               ) : (
//                 <span className={styles.testCallNumber}>
//                   {testCallNumber || "Add your number"}
//                 </span>
//               )}
//               <button
//                 type="button"
//                 className={styles.testCallEdit}
//                 onClick={() => setEditingTestNumber((v) => !v)}
//                 aria-label="Edit number"
//               >
//                 <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
//                   <path
//                     d="M4 20h4l10-10-4-4L4 16v4z"
//                     stroke="#24252C"
//                     strokeWidth="1.6"
//                     strokeLinejoin="round"
//                   />
//                   <path d="M13.5 6.5l4 4" stroke="#24252C" strokeWidth="1.6" />
//                 </svg>
//               </button>
//             </div>

//             {testCallNumber && !isTestCallValid && (
//               <p className={styles.testCallError}>
//                 Enter a valid number starting with +1 or +91 (max 15 digits).
//               </p>
//             )}

//             <p className={styles.testCallConfirm}>
//               Confirm your number &amp; tap <strong>Call Now</strong>
//             </p>

//             <AnimatedButton
//               label="Call Now →"
//               onClick={handleCallNow}
//               disabled={!isTestCallValid}
//               positionType="relative"
//               width="100%"
//               bottom="0px"
//             />

//             <button
//               type="button"
//               className={styles.goBackLink}
//               onClick={closeTestCall}
//             >
//               &lt;&lt;&lt; Go Back to Call Forwarding
//             </button>
//           </div>
//           // <div className={styles.connecting}>
//           //   <h3 className={styles.connectingTitle}>Connecting Call...</h3>
//           //   <p className={styles.connectingSub}>
//           //     Checking if <strong>"{agentName}"</strong> answers your business
//           //     phone.
//           // <div className={styles.testCall}>
//           //   <h3 className={styles.testCallTitle}>Send a Test Call</h3>
//           //   <p className={styles.testCallText}>
//           //     We'll call your <strong>business number</strong>
//           //   </p>
//           //   <p className={styles.testCallSub}>
//           //     If forwarding is set up, <strong>{agentName}</strong> will answers it.
//           //   </p>

//           //   <div className={styles.testCallDashDivider} />

//           //   <div className={styles.connectingRow}>
//           //     <div className={styles.connectingAvatar}>
//           //       <img src="/svg/fav_icon.svg" alt="" />
//           //     </div>

//           //     <div className={styles.connectingMid}>
//           //       <div className={styles.connectingWaitLine}>
//           //         <span className={styles.connectingWait}>PLEASE WAIT...</span>
//           //         <span className={styles.connectingArrows}>›››</span>
//           //       </div>
//           //       <span className={styles.connectingCalling}>
//           //         calling your number now.
//           //       </span>
//           //       <span className={styles.connectingNumber}>{callDisplayNumber}</span>
//           //     </div>

//           //     <div className={styles.connectingPhone}>
//           //       <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//           //         <path d="M14.6268 5.20487C15.6555 5.40519 16.601 5.90735 17.3421 6.64707C18.0833 7.38679 18.5864 8.33042 18.7871 9.35718M14.6268 1C16.7641 1.23698 18.7572 2.19226 20.2787 3.709C21.8003 5.22573 22.7599 7.21376 23 9.34667M21.9468 17.7354V20.889C21.948 21.1818 21.8879 21.4716 21.7704 21.7398C21.6529 22.0081 21.4805 22.2489 21.2644 22.4468C21.0482 22.6447 20.793 22.7954 20.5152 22.8892C20.2373 22.983 19.9429 23.0178 19.6507 22.9915C16.4098 22.64 13.2966 21.5346 10.5613 19.7642C8.01656 18.1503 5.85903 15.9968 4.24197 13.4569C2.46198 10.7145 1.35426 7.59218 1.00855 4.34287C0.982229 4.05217 1.01684 3.75919 1.11019 3.48258C1.20353 3.20597 1.35356 2.95178 1.55072 2.73621C1.74788 2.52064 1.98785 2.34841 2.25535 2.23047C2.52286 2.11254 2.81204 2.05149 3.10448 2.05122H6.26417C6.77531 2.0462 7.27084 2.22685 7.6584 2.55952C8.04595 2.89218 8.29909 3.35415 8.37063 3.85931C8.50399 4.86855 8.75132 5.85949 9.10789 6.81323C9.2496 7.18949 9.28027 7.5984 9.19626 7.99152C9.11226 8.38464 8.91711 8.74549 8.63394 9.0313L7.29633 10.3663C8.79567 12.9981 10.9789 15.1772 13.6157 16.6737L14.9533 15.3386C15.2397 15.056 15.6012 14.8612 15.9951 14.7774C16.389 14.6935 16.7987 14.7241 17.1756 14.8656C18.1312 15.2214 19.124 15.4683 20.1352 15.6014C20.6468 15.6734 21.1141 15.9307 21.4481 16.3241C21.7821 16.7176 21.9596 17.2198 21.9468 17.7354Z" fill="white" />
//           //         <path d="M14.6268 5.20487C15.6555 5.40519 16.601 5.90735 17.3421 6.64707C18.0833 7.38679 18.5864 8.33042 18.7871 9.35718M14.6268 1C16.7641 1.23698 18.7572 2.19226 20.2787 3.709C21.8003 5.22573 22.7599 7.21376 23 9.34667M21.9468 17.7354V20.889C21.948 21.1818 21.8879 21.4716 21.7704 21.7398C21.6529 22.0081 21.4805 22.2489 21.2644 22.4468C21.0482 22.6447 20.793 22.7954 20.5152 22.8892C20.2373 22.983 19.9429 23.0178 19.6507 22.9915C16.4098 22.64 13.2966 21.5346 10.5613 19.7642C8.01656 18.1503 5.85903 15.9968 4.24197 13.4569C2.46198 10.7145 1.35426 7.59218 1.00855 4.34287C0.982229 4.05217 1.01684 3.75919 1.11019 3.48258C1.20353 3.20597 1.35356 2.95178 1.55072 2.73621C1.74788 2.52064 1.98785 2.34841 2.25535 2.23047C2.52286 2.11254 2.81204 2.05149 3.10448 2.05122H6.26417C6.77531 2.0462 7.27084 2.22685 7.6584 2.55952C8.04595 2.89218 8.29909 3.35415 8.37063 3.85931C8.50399 4.86855 8.75132 5.85949 9.10789 6.81323C9.2496 7.18949 9.28027 7.5984 9.19626 7.99152C9.11226 8.38464 8.91711 8.74549 8.63394 9.0313L7.29633 10.3663C8.79567 12.9981 10.9789 15.1772 13.6157 16.6737L14.9533 15.3386C15.2397 15.056 15.6012 14.8612 15.9951 14.7774C16.389 14.6935 16.7987 14.7241 17.1756 14.8656C18.1312 15.2214 19.124 15.4683 20.1352 15.6014C20.6468 15.6734 21.1141 15.9307 21.4481 16.3241C21.7821 16.7176 21.9596 17.2198 21.9468 17.7354Z" stroke="#00C524" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
//           //       </svg>
//           //     </div>
//           //   </div>

//           //   {/* <button
//           //   <div className={styles.testCallNumberRow}>
//           //     {editingTestNumber ? (
//           //       <input
//           //         type="tel"
//           //         inputMode="tel"
//           //         className={styles.testCallInput}
//           //         value={testCallNumber}
//           //         onChange={(e) => setTestCallNumber(formatTestCallNumber(e.target.value))}
//           //         onKeyPress={(e) => {
//           //           // Block letters/symbols at the keystroke level too, so
//           //           // nothing flashes in before the sanitiser runs.
//           //           if (!/[\d+\s()-]/.test(e.key)) e.preventDefault();
//           //         }}
//           //         onBlur={() => setEditingTestNumber(false)}
//           //         placeholder="+1 000-000-0000"
//           //         maxLength={20}
//           //         autoFocus
//           //       />
//           //     ) : (
//           //       <span className={styles.testCallNumber}>
//           //         {testCallNumber || "Add your number"}
//           //       </span>
//           //     )}
//           //     <button
//           //       type="button"
//           //       className={styles.testCallEdit}
//           //       onClick={() => setEditingTestNumber((v) => !v)}
//           //       aria-label="Edit number"
//           //     >
//           //       <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
//           //         <path
//           //           d="M4 20h4l10-10-4-4L4 16v4z"
//           //           stroke="#24252C"
//           //           strokeWidth="1.6"
//           //           strokeLinejoin="round"
//           //         />
//           //         <path d="M13.5 6.5l4 4" stroke="#24252C" strokeWidth="1.6" />
//           //       </svg>
//           //     </button>
//           //   </div>

//           //   {testCallNumber && !isTestCallValid && (
//           //     <p className={styles.testCallError}>
//           //       Enter a valid number starting with +1 or +91 (max 15 digits).
//           //     </p>
//           //   )}

//           //   <p className={styles.testCallConfirm}>
//           //     Confirm your number &amp; tap <strong>Call Now</strong>
//           //   </p>

//           //   <AnimatedButton
//           //     label="Call Now →"
//           //     onClick={handleCallNow}
//           //     disabled={!isTestCallValid}
//           //     positionType="relative"
//           //     width="100%"
//           //     bottom="0px"
//           //   />

//           //   <button
//           //     type="button"
//           //     className={styles.goBackLink}
//           //     onClick={closeTestCall}
//           //   >
//           //     &lt;&lt;&lt; Go Back to Call Forwarding
//           //   </button> */}
//           // </div>
//           //   </button>
//           // </div>
//         )}
//       </Modal>
//     </div>
//   );
// };

// export default ForwardInstructions;
// // 
import React, { useEffect, useRef, useState } from "react";
import styles from "./ForwardInstructions.module.css";
import AnimatedButton from "../AnimatedButton/AnimatedButton";
import { useNavigate, useLocation } from "react-router-dom";
import { API_BASE_URL, fetchAgentDetailById, updateAgent, startForwardingTestCall, getForwardingTestCallStatus } from "../../Store/apiStore";
import { useAgentStore } from "../../Store/agentDetailStore";
import decodeToken from "../../lib/decodeToken";
import Loader2 from "../Loader2/Loader2";
import Modal from "../Modal/Modal";

import PopUp from "../Popup/Popup";
import { trackEvent } from "../../lib/analytics";
import { secureStorage } from "../../utils/secureStorage";
import {
  buildForwardingSteps,
  normalizeConditions,
  isUnconditional,
  readStoredConditions,
  clearStoredConditions,
  formatNumberForNetwork,
  getNetworkForCarrier,
} from "../../lib/callForwardingCodes";
import { usesVobiz } from "../../utils/apiBackend";

// Kept in sync with SelectCarrier.js `categories`. Each MVNO uses its
// parent network's dial codes — Cricket/Metro/Boost/Mint/Consumer
// Cellular/Google Fi ride T-Mobile or AT&T GSM (**21*{number}#); Visible/
// Xfinity/Spectrum ride Verizon CDMA (*72{number}). Canadian flanker
// brands follow their parent (Fido→Rogers GSM, Koodo→Telus CDMA,
// Virgin/Lucky→Bell CDMA, Chatr→Rogers GSM, Public→Telus CDMA).
const callForwardingConfig = {
  // 🇺🇸 US — majors (GSM)
  "AT&T": { activate: "**21*{number}#", deactivate: "##21#" },
  "T-Mobile US": { activate: "**21*{number}#", deactivate: "##21#" },

  // 🇺🇸 US — majors (CDMA)
  "Verizon": { activate: "*72{number}", deactivate: "*73" },
  "U.S. Cellular": { activate: "*72{number}", deactivate: "*73" },

  // 🇺🇸 US — MVNOs (GSM, T-Mobile / AT&T backed)
  "Cricket Wireless": { activate: "**21*{number}#", deactivate: "##21#" },
  "Metro by T-Mobile": { activate: "**21*{number}#", deactivate: "##21#" },
  "Boost Mobile": { activate: "**21*{number}#", deactivate: "##21#" },
  "Mint Mobile": { activate: "**21*{number}#", deactivate: "##21#" },
  "Consumer Cellular": { activate: "**21*{number}#", deactivate: "##21#" },
  "Google Fi": { activate: "**21*{number}#", deactivate: "##21#" },

  // 🇺🇸 US — MVNOs (CDMA, Verizon backed)
  "Visible": { activate: "*72{number}", deactivate: "*73" },
  "Xfinity Mobile": { activate: "*72{number}", deactivate: "*73" },
  "Spectrum Mobile": { activate: "*72{number}", deactivate: "*73" },

  // 🇨🇦 Canada — majors (GSM)
  "Rogers": { activate: "**21*{number}#", deactivate: "##21#" },
  "Freedom Mobile": { activate: "**21*{number}#", deactivate: "##21#" },

  // 🇨🇦 Canada — majors (CDMA)
  "Bell": { activate: "*72{number}", deactivate: "*73" },
  "Telus": { activate: "*72{number}", deactivate: "*73" },

  // 🇨🇦 Canada — flanker brands
  "Fido": { activate: "**21*{number}#", deactivate: "##21#" },
  "Chatr Mobile": { activate: "**21*{number}#", deactivate: "##21#" },
  "Koodo": { activate: "*72{number}", deactivate: "*73" },
  "Public Mobile": { activate: "*72{number}", deactivate: "*73" },
  "Virgin Plus": { activate: "*72{number}", deactivate: "*73" },
  "Lucky Mobile": { activate: "*72{number}", deactivate: "*73" },
};

// DEV/UI flag — when true, "Call Now" just opens the "Connecting Call…"
// popup and FREEZES it there (no real call, no polling, no auto-advance to
// success/fail) so the connecting UI can be styled. Flip back to `false`
// to restore the normal test-call flow.
const FREEZE_CONNECTING_POPUP = false;

const ForwardInstructions = ({
  // Wizard integration — when true, exit paths hand off to the provided
  // callbacks instead of routing to /fast-agent-detail. Both CTAs
  // ("I've done this" via carrier codes, and "Using agent number
  // directly") also PATCH the agent row so reporting can tell which
  // forwarding path the user picked.
  wizardMode = false,
  onWizardDone,
  onWizardBack,
  // Hides the "I will publish AI Receptionist number directly — Dashboard"
  // escape-hatch CTA. PostPurchaseSetup keeps it visible (default false)
  // because users coming from a paid checkout may legitimately want to
  // use the agent number directly. GoLiveWizard passes true so the
  // post-Number-purchase free-user flow can't bail out of forwarding —
  // they bought a number, the expectation is they will forward to it.
  hideDirectPublishCta = false,
  // agentCtx — passed down by PostPurchaseSetup. Primary source of
  // truth for the just-purchased voip number, since sessionStorage
  // (the legacy source) gets wiped when the user closes the tab and
  // reopens the wizard URL — leaving the steps panel with an empty
  // phone number even though the agent IS provisioned in the DB.
  agentCtx,
  // Agent display name for the "I will publish ${name}'s number directly"
  // skip-helper line. Defaults to "Sophia" only as a final fallback —
  // wrappers should pass `agentCtx.agent.agentName` so the user sees
  // their actual receptionist name.
  agentName: agentNameProp = "",
  /*
   * Conditional call forwarding (GoLive wizard). Condition keys picked on
   * the "When Call Forwarding?" sheet — e.g. ["busy","unanswered"].
   *
   *   []                 → legacy single unconditional code (unchanged)
   *   1 resolved code    → same single-code screen, condition-specific code
   *   2+ resolved codes  → numbered list, each dialed one at a time
   *
   * Falls back to sessionStorage so a reload on this screen keeps the
   * user's selection instead of silently dropping to unconditional.
   */
  forwardingConditions = [],
} = {}) => {
  // Resolved agent name — prefer explicit prop, then agentCtx, then
  // the default seed name new agents get at creation time.
  const agentName =
    agentNameProp ||
    agentCtx?.agent?.agentName ||
    agentCtx?.agent?.name ||
    "Sophia";
  const {
    setAgentById,
    getAgentById,
  } = useAgentStore();
  const navigate = useNavigate();
  const location = useLocation();
  const token = localStorage.getItem("token") || "";
  const decodeTokenData = decodeToken(token);
  const userId = decodeTokenData?.id || "";
  // ── Carrier resolution — 4-layered fallback ──────────────────────
  // Earlier carrier was read only from location.state OR sessionStorage,
  // both of which die when the user closes the tab. Result: a reopened
  // wizard fell through to the `*72{number}` default (Verizon CDMA),
  // which dialed the WRONG forwarding code for AT&T / T-Mobile / etc.
  // users → carrier-side forwarding silently broke. Fallback chain:
  //
  //   Layer 1: location.state.carrier        (direct navigation, fresh)
  //   Layer 2: sessionStorage["selectedCarrier"]  (per-tab cache)
  //   Layer 3: localStorage scoped by agentId     (browser-close survival)
  //   Layer 4: agentCtx.agent.forwardingCarrier   (DB, only if previously saved)
  //
  // First non-empty wins. Read at render time so component picks up
  // updates from any layer without explicit subscription.
  const _agentIdForCarrier = sessionStorage.getItem("SelectAgentId");
  const carrierFromState = location?.state?.carrier;
  const carrierFromSession = sessionStorage.getItem("selectedCarrier");
  let carrierFromLocal = "";
  try {
    if (_agentIdForCarrier) {
      carrierFromLocal = localStorage.getItem(`postPurchase.carrier.${_agentIdForCarrier}`) || "";
    }
  } catch {
    /* private mode quota — silent fallback to other layers */
  }
  const carrierFromAgent = agentCtx?.agent?.forwardingCarrier || "";
  const carrier =
    carrierFromState ||
    carrierFromSession ||
    carrierFromLocal ||
    carrierFromAgent ||
    "";
  // const token = localStorage.getItem("token") || "";
  // const { id: userId } = decodeToken(token) || {};
  const [doneLoading, setDoneLoading] = useState(false);


  // Config get karo
  const config = callForwardingConfig[carrier] || {
    activate: "*72{number}",
    deactivate: "*73",
  };

  const isInitialLoad = useRef(true);
  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState("");
  const [popupMessage, setPopupMessage] = useState("");
  const [selectedNumber, setSelectedNumber] = useState("");
  // Mobile-only "Do it now" → tel: dialer flow.
  //
  // We detect ONLY phones (iPhone + Android phones). Tablets are
  // intentionally treated as desktop because (a) iPads can't dial
  // standard *72 carrier codes and (b) Android tablets often lack a
  // SIM. Strict UA sniff — modern phones still report "Mobile" in UA.
  //
  // hasOpenedDialer flips to true the FIRST time the user returns to
  // the tab after tapping "Do it now" (visibilitychange listener
  // below), at which point the CTA flips to "I've done this" so they
  // can confirm + persist the carrier choice and move on.
  const isMobilePhone = (() => {
    if (typeof navigator === "undefined") return false;
    const ua = navigator.userAgent || "";
    // Phone-class UA patterns. Includes:
    //   - iPhone/iPod (covers iOS Safari + iOS WKWebView in native apps)
    //   - Android.*Mobile (Chrome on Android)
    //   - Android.*wv (Android WebView used inside native/Capacitor/
    //     Cordova/React-Native apps — earlier this was missing and
    //     visitors inside webview shells fell through to the desktop
    //     "I've done this" CTA)
    //   - Mobi (generic token most Chromium-derived mobile browsers emit)
    //   - BlackBerry / IEMobile / Opera Mini for the long tail
    // Viewport width is intentionally NOT used as a signal — narrow
    // desktop windows would false-positive into the dialer flow.
    const phoneUA =
      /iPhone|iPod|Android.*Mobile|Android.*wv|BlackBerry|IEMobile|Opera Mini|Mobi/i.test(
        ua,
      );
    if (typeof window !== "undefined" && window.console) {
      // Single-line debug — quick to grep when a real device shows the
      // wrong CTA. Remove later once telemetry confirms parity.
      console.log("[ForwardInstructions] mobile detect:", { ua, phoneUA });
    }
    return phoneUA;
  })();
  const [hasOpenedDialer, setHasOpenedDialer] = useState(false);
  // Transient "opening dialer" state — between tap and the final
  // "I've done this" CTA. Without it the button label flipped
  // instantly which felt jarring (no acknowledgement of the click).
  // 1.5s loader phase makes the transition feel intentional.
  const [openingDialer, setOpeningDialer] = useState(false);
  // "Did it work?" confirmation modal — shown after the user taps
  // "Forward My Calls Now" (dialer opens, then on returning to the tab
  // this asks them to confirm forwarding actually activated).
  const [showDidItWork, setShowDidItWork] = useState(false);
  // "Call forwarding Help" modal — shown when the user taps "No, it
  // didn't" on the "Did it work?" prompt. Lists the common fixes and
  // offers a "Submit Support Ticket" exit into the ticket flow.
  const [showCallHelp, setShowCallHelp] = useState(false);
  // "Forwarding calls to {agent}" reminder banner on the manual-steps
  // (Step 2) view. Surfaced when the user taps "Show Me the Steps Again"
  // from the failed test-call screen — it sits above the Direct Dial card
  // with its own Try again / Get help actions.
  //
  // 🎨 DESIGN FLAG — set to `true` to force the banner visible on page load
  // so it can be styled without going through the failed-test-call flow.
  // Flip back to `false` to restore the normal trigger-based behaviour.
  const [showForwardingBanner, setShowForwardingBanner] = useState(false);
  // "Send a Test Call" modal — opened from "Yes, it did" (and the
  // "Send a test call" link). Lets the user confirm/edit their own
  // business number; tapping Call Now triggers an outbound test call
  // (API wired separately) that should route through to the agent if
  // forwarding is live.
  const [showTestCall, setShowTestCall] = useState(false);
  const [testCallNumber, setTestCallNumber] = useState("");
  const [editingTestNumber, setEditingTestNumber] = useState(false);
  // Flips to the "Connecting Call…" view inside the test-call modal once
  // the user taps Call Now (while the outbound call is being placed).
  const [callConnecting, setCallConnecting] = useState(false);
  // Flips to the "You're live!" success view ~1s after connecting.
  // const [callSuccess, setCallSuccess] = useState(false);
  const [callSuccess, setCallSuccess] = useState(false);
  // Flips to the "Almost there — forwarding isn't active yet" view.
  const [callFailed, setCallFailed] = useState(false);
  // Tracks the connecting→success timer so we can clear it if the user
  // backs out of the modal before it resolves.
  const callTimerRef = useRef(null);
  const forwardingBannerRef = useRef(null);

  // ── Conditional forwarding ───────────────────────────────────────
  // Prop wins; sessionStorage covers a reload on this screen. Empty =
  // legacy unconditional behaviour.
  const conditions = normalizeConditions(
    forwardingConditions?.length ? forwardingConditions : readStoredConditions(),
  );
  // buildForwardingSteps merges conditions that resolve to the SAME code
  // (CDMA has one `*71` for busy/unanswered/unreachable), so a 3-condition
  // CDMA pick renders as ONE step, not three identical ones.
  const forwardingSteps = buildForwardingSteps(carrier, selectedNumber, conditions);
  // hasConditions gates the whole condition layout (title, rows, confirm
  // link). isMultiStep only picks which helper card sits below it.
  const hasConditions = forwardingSteps.length > 0;
  const isMultiStep = forwardingSteps.length > 1;
  // Per-row "Copied" flash, keyed by step order.
  const [copiedStep, setCopiedStep] = useState(null);

  // Activation code for the single-code screen — condition-specific when the
  // sheet was used, otherwise the carrier's unconditional default.
  //
  // The legacy branch MUST run the number through formatNumberForNetwork too:
  // voip_numbers are stored E.164, but CDMA carriers reject the country code
  // ("*72 + the 10-digit number" per Verizon), so `*72+19495557890` never
  // activated forwarding for Verizon/Bell/Telus/Visible/Xfinity/etc.
  // The agent number in the form this carrier's dialer expects. Used both
  // INSIDE the dial code and by the legacy "Enter your AI phone number" box,
  // so the two can never disagree about whether to include the +1.
  const dialNumber = formatNumberForNetwork(
    selectedNumber || "",
    getNetworkForCarrier(carrier),
  );

  const primaryCode =
    forwardingSteps[0]?.code ||
    (config.activate || "").replace("{number}", dialNumber);

  // tel: link with the activation code. `#` MUST be %23-encoded or
  // browsers truncate at the fragment separator and the dialer dials
  // only the prefix. iOS + Android both accept `*` and `+` literally.
  const telHrefFor = (code) =>
    code && selectedNumber ? `tel:${code.replace(/#/g, "%23")}` : "";

  const dialerHref = telHrefFor(primaryCode);

  // "Do it now" handler — flip the CTA state IMMEDIATELY before
  // navigating to the dialer, then open it. Earlier we waited for a
  // `visibilitychange` event after the user returned from the dialer,
  // but that event is unreliable across mobile browsers and webviews:
  //   - Some webviews keep the tab "visible" because the dialer
  //     opens as a chrome layer instead of backgrounding the page.
  //   - Some browsers (older Android Chrome, certain in-app browsers)
  //     don't fire visibilitychange on tel: navigations at all.
  // Net effect was the button stayed "Do it now" forever and the
  // wizard couldn't advance. Immediate flip gives us deterministic
  // UX: tap → button instantly becomes "I've done this", dialer
  // opens in parallel. When the user returns they see the next CTA.
  // 1.5s loader phase between tap and the "I've done this" CTA.
  // Sequence:
  //   T+0ms    : tap → button shows spinner ("Opening dialer…")
  //   T+0ms    : window.location navigates to tel: URI
  //   T+1500ms : spinner clears → CTA flips to "I've done this"
  // Even if the user is in the dialer when the timer fires (most
  // common case), they return to the new label instead of seeing an
  // abrupt mid-flight swap.
  const DIALER_TRANSITION_MS = 1500;
  // Unified primary-CTA handler. Shows the "Did it work?" confirmation
  // IMMEDIATELY on click (don't defer into the timeout — a tel:
  // navigation can suspend JS and swallow it). On a real phone we also
  // open the native dialer pre-filled with the activation code; the
  // popup is already up so it's there when the user returns.
  const handleForwardNowClick = () => {
    // GA4: user kicked off carrier-side forwarding (opens dialer with the
    // activation code). method tells dialer vs. confirm-only (desktop).
    trackEvent("call_forwarding_initiated", {
      carrier: carrier || "",
      method: isMobilePhone && !hasOpenedDialer && dialerHref ? "dialer" : "manual",
    });
    setShowDidItWork(true);
    if (isMobilePhone && !hasOpenedDialer && dialerHref) {
      setOpeningDialer(true);
      window.location.href = dialerHref;
      setTimeout(() => {
        setOpeningDialer(false);
        setHasOpenedDialer(true);
      }, DIALER_TRANSITION_MS);
    }
  };

  // Business phone number — the number we place the test call to. If
  // forwarding is set up, that call rings through to the agent. Prefer the
  // business record (from agentCtx, then the agent store cache — which
  // survives when agentCtx isn't passed in this flow), and only fall back
  // to the decoded token's phone.
  const cachedBusiness =
    getAgentById(sessionStorage.getItem("SelectAgentId"))?.agentData?.business || null;
  // Business details captured during onboarding (StepTwo) are stashed in
  // secureStorage under `placeDetailsExtract` — its phone is the business
  // number when agentCtx/store don't carry it yet.
  const placeDetails = secureStorage.get("placeDetailsExtract", {}) || {};
  const businessOwnerNumber =
    agentCtx?.business?.phoneNumber ||
    agentCtx?.business?.phone ||
    cachedBusiness?.phoneNumber ||
    cachedBusiness?.phone ||
    placeDetails?.phone ||
    placeDetails?.internationalPhone ||
    decodeTokenData?.phone ||
    decodeTokenData?.phoneNumber ||
    "";

  // Phone-input formatter — strips everything to digits (so letters can
  // never land), caps at 15 digits (E.164 max), then re-groups into a
  // dashed, country-coded format:
  //   +1  → +1-XXX-XXX-XXXX   (US / Canada)
  //   +91 → +91-XXXXX-XXXXX   (India)
  // Until a recognised country code is typed it just shows the raw
  // digits, so the user can start with "1" or "9".
  // Which country this screen's test-call number belongs to. The domain
  // decides it — usesVobiz() is the same India/US switch the number-purchase
  // and address screens already run on — and an explicitly typed country code
  // still wins, so a US owner on the India site is not locked out.
  const testCallCountry = (digits) => {
    if (digits.startsWith("91")) return "IN";
    if (digits.startsWith("1")) return "US";
    return usesVobiz() ? "IN" : "US";
  };
  const testCallMaxDigits = (digits) =>
    testCallCountry(digits) === "IN" ? 12 : 11;

  const formatTestCallNumber = (raw) => {
    const all = (raw.match(/\d/g) || []).join("");
    // The cap follows the country, not a fixed 11. A hard 11 chopped the last
    // digit off every Indian number (+91 is 12 digits with the code), so the
    // field showed a truncated number and then refused it as invalid.
    // On an India site a bare 10-digit national number is Indian too, so the
    // cap cannot wait for the "91" prefix to be typed.
    const digits = all.slice(0, testCallMaxDigits(all));
    if (!digits) return "";

    let cc = "";
    let rest = digits;
    // "91" is checked first, and the two cannot collide: an Indian number
    // starts with 9, a US/Canada one with 1.
    if (digits.startsWith("91")) {
      cc = "91";
      rest = digits.slice(2);
    } else if (digits.startsWith("1")) {
      cc = "1";
      rest = digits.slice(1);
    }

    if (!cc) return digits; // no country code yet → plain digits

    // Group the national part per country code.
    const groups = cc === "91" ? [5, 5] : [3, 3, 4];
    const parts = [];
    let i = 0;
    for (const g of groups) {
      if (i >= rest.length) break;
      parts.push(rest.slice(i, i + g));
      i += g;
    }
    // Any overflow digits (shouldn't happen within 15-cap) tack on.
    if (i < rest.length) parts.push(rest.slice(i));

    return parts.length ? `+${cc}-${parts.join("-")}` : `+${cc}`;
  };

  // Controlled formatted input -> cursor-jump fix.
  //
  // The value is re-formatted (dashes / "+1-" re-inserted) on every
  // keystroke, so React rewrites the whole string and the browser drops
  // the caret to the END -- editing/deleting in the MIDDLE always snapped
  // to the end. We anchor the caret by DIGIT COUNT instead of raw index:
  // count digits left of the caret before formatting, then after the
  // formatted value is applied, place the caret right after that many
  // digits. Dashes shifting around no longer matters.
  const handleTestNumberChange = (e) => {
    const el = e.target;
    const rawValue = el.value;
    const rawCaret = el.selectionStart ?? rawValue.length;
    const digitsLeft = (rawValue.slice(0, rawCaret).match(/\d/g) || []).length;

    const formatted = formatTestCallNumber(rawValue);
    setTestCallNumber(formatted);

    // Restore the caret after React commits the new controlled value.
    requestAnimationFrame(() => {
      if (!el) return;
      let pos;
      if (digitsLeft <= 0) {
        pos = 0;
      } else {
        let seen = 0;
        pos = formatted.length;
        for (let i = 0; i < formatted.length; i++) {
          if (/\d/.test(formatted[i])) {
            seen++;
            if (seen === digitsLeft) {
              pos = i + 1;
              break;
            }
          }
        }
      }
      try {
        el.setSelectionRange(pos, pos);
      } catch {
        /* element detached / unsupported -- ignore */
      }
    });
  };

  // Open the "Send a Test Call" modal — close the "Did it work?" popup
  // and seed the number field with the owner's number (only if the user
  // hasn't already edited it this session).
  const openTestCall = () => {
    setShowDidItWork(false);
    setEditingTestNumber(false);
    setCallConnecting(false);
    setCallSuccess(false);
    setCallFailed(false);
    if (callTimerRef.current) clearTimeout(callTimerRef.current);
    setTestCallNumber((prev) => prev || formatTestCallNumber(businessOwnerNumber));
    setShowTestCall(true);
  };

  // Deep-link entry — lifecycle "Run test call" / "Run forwarding test" nudges
  // (liveNoCalls, dormant) land here as /forward-instructions?action=testcall.
  // Read ?agentId= so a cold email arrival targets the right agent, then
  // auto-open the "Send a Test Call" modal so the user goes straight into the
  // forwarding-test flow instead of hunting for the button.
  useEffect(() => {
    const q = new URLSearchParams(location.search);
    const qAgent = q.get("agentId");
    if (qAgent) {
      try { sessionStorage.setItem("SelectAgentId", qAgent); } catch { /* private mode */ }
    }
    if (q.get("action") === "testcall") {
      const t = setTimeout(() => openTestCall(), 350); // let owner-number load first
      return () => clearTimeout(t);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);

  // Cold-arrival safety net: the modal may auto-open (350ms) before the async
  // business fetch resolves, seeding an EMPTY number. Once the owner number
  // arrives, seed it — but only while the modal is open and the user hasn't
  // typed their own. Additive: no effect on the warm path (number already there).
  useEffect(() => {
    if (showTestCall && !editingTestNumber && !testCallNumber && businessOwnerNumber) {
      setTestCallNumber(formatTestCallNumber(businessOwnerNumber));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showTestCall, editingTestNumber, testCallNumber, businessOwnerNumber]);

  // National-part display (drops the "+1-" / "+91-" country prefix) for
  // the "Connecting Call…" screen, matching the design.
  const callDisplayNumber = testCallNumber.replace(/^\+\d{1,3}-/, "");

  const closeTestCall = () => {
    if (callTimerRef.current) clearTimeout(callTimerRef.current);
    setShowTestCall(false);
    setCallConnecting(false);
    setCallSuccess(false);
    setCallFailed(false);
  };

  const scrollForwardingBannerIntoView = () => {
    requestAnimationFrame(() => {
      forwardingBannerRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    });
  };

  // Back to the "Send a Test Call" form (from the failed screen) so the
  // user can dial + retry.
  const handleTestCallAgain = () => {
    if (callTimerRef.current) clearTimeout(callTimerRef.current);
    setCallConnecting(false);
    setCallSuccess(false);
    setCallFailed(false);
  };

  // "Get help" — reach support. Defaults to a mailto; rewire to your
  // in-app help/chat if you have one.
  const handleGetHelp = () => {
    window.location.href =
      "mailto:support@rxpt.us?subject=Call%20forwarding%20help";
  };

  // ── Failed test-call screen actions ──────────────────────────────
  // "Test call again" (failed screen) / "Try again" (reminder banner) →
  // re-place the test call DIRECTLY (skip the form) and surface the
  // Connecting view. testCallNumber persists from the previous attempt;
  // we seed it from the owner's number as a fallback so the call can
  // still go out even if it was somehow cleared.
  const handleRetryTestCall = () => {
    setShowDidItWork(false);
    setShowCallHelp(false);
    setShowTestCall(true);
    setTestCallNumber((prev) => prev || formatTestCallNumber(businessOwnerNumber));
    handleCallNow();
  };

  // "Get help" (failed screen) → open the "Call forwarding Help" ticket
  // popup instead of a mailto.
  const handleFailedGetHelp = () => {
    openCallHelp("failed_call");
    closeTestCall();
  };

  // Open the "Call forwarding Help" modal + log where the user came from.
  const openCallHelp = (from) => {
    trackEvent("call_forwarding_help_opened", { from: from || "" });
    setShowCallHelp(true);
  };

  // "Show Me the Steps Again" → return to the manual-steps (Step 2) view
  // and reveal the "Forwarding calls to {agent}" reminder banner.
  const handleShowStepsAgain = () => {
    // GA4: user went back to re-read the manual forwarding steps.
    trackEvent("call_forwarding_steps_reshown");
    closeTestCall();
    setShowForwardingBanner(true);
    scrollForwardingBannerIntoView();
  };

  // A number is "callable" only at its country's full length, INCLUDING the
  // country code:
  //   US / Canada  +1-XXX-XXX-XXXX     → 11 digits
  //   India        +91-XXXXX-XXXXX     → 12 digits
  // Only "1" was accepted before, so a perfectly valid Indian number was
  // rejected with a message telling the owner to start it with +1.
  const testCallDigitStr = (testCallNumber.match(/\d/g) || []).join("");
  const isIndiaTestCall = testCallCountry(testCallDigitStr) === "IN";
  const isTestCallValid = isIndiaTestCall
    ? testCallDigitStr.startsWith("91") && testCallDigitStr.length === 12
    : testCallDigitStr.startsWith("1") && testCallDigitStr.length === 11;

  // "Call Now" — place the real outbound test call (agent Telnyx number →
  // owner's number). The backend reports back whether the call forwarded
  // to the agent (Retell answered) or never connected. We show the
  // "Connecting…" view, then poll the status until it resolves.
  const handleCallNow = async () => {
    if (!isTestCallValid) return;
    // GA4: forwarding-verification test call placed (distinct from the
    // onboarding activation `test_call_*` preview). Covers retries too.
    trackEvent("call_forwarding_test_call_start", { carrier: carrier || "" });
    setCallConnecting(true);
    setCallSuccess(false);
    setCallFailed(false);
    if (callTimerRef.current) clearTimeout(callTimerRef.current);

    // UI-work mode — keep the "Connecting Call…" popup frozen on screen.
    // Skip the API call + polling so it never advances. Set
    // FREEZE_CONNECTING_POPUP = false to restore normal behaviour.
    if (FREEZE_CONNECTING_POPUP) return;
    console.log(selectedNumber, testCallNumber, "selectedNumber, testCallNumber")
    try {
      // `from` = agent's Telnyx number (the one owner forwards to); the
      // backend may override this with a dedicated caller number via env.
      const data = await startForwardingTestCall(selectedNumber, testCallNumber);
      console.log(data, "data")
      const testId = data?.testCallId;
      if (!data?.success || !testId) {
        trackEvent("call_forwarding_test_call_failed", {
          carrier: carrier || "",
          reason: "no_test_id",
        });
        setCallConnecting(false);
        setCallFailed(true);
        return;
      }

      const startedAt = Date.now();
      const poll = async () => {
        let status = "calling";
        try {
          const r = await getForwardingTestCallStatus(testId);
          status = r?.status || "calling";
        } catch {
          /* transient — keep polling */
        }

        if (status === "forwarded") {
          // GA4: test call routed to the agent → forwarding verified live.
          trackEvent("call_forwarding_test_call_success", {
            carrier: carrier || "",
          });
          setCallConnecting(false);
          setCallSuccess(true);
          return;
        }
        if (status === "failed") {
          trackEvent("call_forwarding_test_call_failed", {
            carrier: carrier || "",
            reason: "not_forwarded",
          });
          setCallConnecting(false);
          setCallFailed(true);
          return;
        }
        // 'calling' / 'unknown' → keep polling until the 45s ceiling.
        if (Date.now() - startedAt > 45000) {
          trackEvent("call_forwarding_test_call_failed", {
            carrier: carrier || "",
            reason: "timeout",
          });
          setCallConnecting(false);
          setCallFailed(true);
          return;
        }
        callTimerRef.current = setTimeout(poll, 2000);
      };
      callTimerRef.current = setTimeout(poll, 2000);
    } catch (err) {
      console.error("[ForwardInstructions] test call failed:", err);
      trackEvent("call_forwarding_test_call_failed", {
        carrier: carrier || "",
        reason: "error",
      });
      setCallConnecting(false);
      setCallFailed(true);
    }
  };

  // "Next: Set Up Call Triage" — success path. Forwarding is confirmed
  // live (the test call routed to the agent), so run the normal done
  // flow: persist the choice + advance the wizard to Call Triage.
  const handleNextTriage = () => {
    closeTestCall();
    handleDone();
  };

  // Clear any pending connecting→success timer if the component unmounts.
  useEffect(() => {
    return () => {
      if (callTimerRef.current) clearTimeout(callTimerRef.current);
    };
  }, []);

  // "Yes, it did" — forwarding confirmed. Per updated flow we advance the
  // user straight to the next onboarding step (Call Triage) instead of
  // opening the test-call screen. handleDone persists the "carrier"
  // choice and hands off to the wizard (onWizardDone → next step).
  const handleDidItWorkYes = () => {
    setShowDidItWork(false);
    handleDone();
  };

  // "No, it didn't" — forwarding isn't active yet. Close the prompt and
  // reveal the "Forwarding calls to {agent}" reminder banner on the
  // manual-steps view (with its own Try again / Get help actions). From
  // that banner, "Get help" opens the "Call forwarding Help" popup.
  const handleDidItWorkNo = () => {
    // GA4: user self-reported forwarding did NOT activate.
    trackEvent("call_forwarding_not_working", { carrier: carrier || "" });
    setShowDidItWork(false);
    setShowForwardingBanner(true);
    scrollForwardingBannerIntoView();
  };

  // "Submit Support Ticket" — leave the wizard for the ticket flow.
  // Stash a return descriptor so that once the ticket is raised the
  // user is brought back to the wizard's NEXT step (Call Triage, internal
  // step 4) rather than back onto the Forwarding step. See CreateTicket
  // handleSubmit for the matching read of `ticketReturn`.
  const handleSubmitSupportTicket = () => {
    // This button only OPENS the ticket flow (it lands on the tickets list);
    // no ticket exists yet. It used to fire call_forwarding_support_ticket_submitted
    // here, which counted every click as a submitted ticket. The real
    // "submitted" event now fires from CreateTicket once the ticket is saved.
    trackEvent("call_forwarding_support_ticket_opened");
    try {
      sessionStorage.setItem(
        "ticketReturn",
        // "from" tells CreateTicket this ticket came from call forwarding, so
        // it can fire call_forwarding_support_ticket_submitted on a real save.
        JSON.stringify({ path: "/go-live-setup", goLiveStep: 4, from: "call_forwarding" }),
      );
    } catch {
      /* private mode / quota — ticket flow still works, just lands on list */
    }
    setShowCallHelp(false);
    navigate("/raise-tickets");
  };
  // Inline copy feedback — appears directly under the copy icon for
  // ~1.8s. Avoids relying solely on the global popup which is easy to
  // miss on a crowded screen.
  const [copiedFlash, setCopiedFlash] = useState(false);
  // Cold WebView / email deep-link (/forward-instructions?agentId=…): session is
  // empty, so read agentId from the URL so the agent/business (+ test-call number)
  // fetch starts on the FIRST render, not only after the modal forces a re-render.
  // Additive — warm in-app navigation (session set) wins, unchanged.
  const agentId =
    sessionStorage.getItem("SelectAgentId") ||
    new URLSearchParams(location.search).get("agentId") ||
    "";
  const agentBuisnesId = sessionStorage.getItem("SelectAgentBusinessId");

  // ── Voip retention — 3-layered hydration ─────────────────────────
  // Production bug spotted: user purchases a number on Step 4, leaves
  // the wizard, comes back via URL (sessionStorage gone) → Step 7
  // landed with an EMPTY phone number even though the agent's
  // voip_numbers column was populated. Layered fallback below ensures
  // the number is always rendered as long as ANY of these survive:
  //
  //   Layer 1: agentCtx prop (parent already has fresh DB data)
  //   Layer 2: localStorage cache (survives browser close/reopen)
  //   Layer 3: existing API fetch (deeper down in this file)
  //
  // All three are idempotent — first one to find a value wins, the
  // rest skip via the `selectedNumber` guard.
  // localStorage key is SCOPED by agentId so two tabs running the
  // wizard for different agents don't read each other's voip cache.
  // Earlier this was a single global key — tab A's voip would leak
  // into tab B's UI even though B's agent was a different record.
  // Returning "" when agentId is missing makes the key effectively
  // a no-op (writes/reads silently skip).
  const voipKeyFor = (id) => (id ? `postPurchase.voip.${id}` : "");

  // Layer 1 — agentCtx from parent wizard (most up-to-date)
  useEffect(() => {
    if (selectedNumber) return;
    const voip = agentCtx?.agent?.voip_numbers;
    if (!voip) return;
    try {
      const parsed = typeof voip === "string" ? JSON.parse(voip) : voip;
      const first = Array.isArray(parsed) ? parsed[0] : parsed;
      if (first) {
        setSelectedNumber(first);
        // Mirror to localStorage so a subsequent browser-close visit
        // can recover via Layer 2 even if agentCtx isn't ready yet.
        try {
          const k = voipKeyFor(agentId);
          if (k) localStorage.setItem(k, first);
        } catch { }
      }
    } catch {
      /* malformed voip_numbers — fall through to other layers */
    }
  }, [agentCtx?.agent?.voip_numbers, selectedNumber]);

  // Layer 2 — localStorage cache (browser close/reopen scenario)
  useEffect(() => {
    if (selectedNumber) return;
    try {
      const k = voipKeyFor(agentId);
      const cached = k ? localStorage.getItem(k) : null;
      if (cached) setSelectedNumber(cached);
    } catch {
      /* private mode / quota issues — silent fallback to Layer 3 */
    }
    // Run once on mount only — Layer 1 above re-fires on agentCtx
    // changes, so we don't need this to react to anything.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Generate step 1 text with actual number
  const getActivateInstruction = () => {
    if (!selectedNumber) return forwardingSteps[0]?.code || config.activate;
    return primaryCode;
  };

  // ── Multi-step handlers ──────────────────────────────────────────
  // Copy one row's code. Own flash state per row so two rows can't both
  // show "Copied" at once.
  const handleCopyStepCode = async (step) => {
    try {
      await navigator.clipboard.writeText(step.code);
      setCopiedStep(step.order);
      setTimeout(() => setCopiedStep((c) => (c === step.order ? null : c)), 1800);
      trackEvent("call_forwarding_code_copied", {
        carrier: carrier || "",
        condition: step.conditions.join(","),
        step_index: step.order,
      });
    } catch (error) {
      console.error("Failed to copy code:", error);
      setPopupType("error");
      setPopupMessage("Failed to copy");
      setShowPopup(true);
    }
  };

  // "I've completed these steps" — the user says they've dialed everything.
  // Hands off to the same "Did it work?" confirmation the single-code CTA
  // opens, so both layouts share one completion path.
  const handleAllStepsDone = () => {
    trackEvent("call_forwarding_all_steps_done", {
      carrier: carrier || "",
      condition_count: conditions.length,
      code_count: forwardingSteps.length,
    });
    setShowDidItWork(true);
  };

  // Copy number to clipboard. Copies the DIAL form, not the stored E.164 —
  // this box sits inside the forwarding steps, so whatever the user pastes
  // has to be what their carrier accepts after the activation code.
  const handleCopyNumber = async () => {
    if (!selectedNumber) {
      setPopupType("warning");
      setPopupMessage("No number to copy");
      setShowPopup(true);
      return;
    }
    try {
      await navigator.clipboard.writeText(dialNumber || selectedNumber);
      setCopiedFlash(true);
      setTimeout(() => setCopiedFlash(false), 1800);
    } catch (error) {
      console.error("Failed to copy:", error);
      setPopupType("error");
      setPopupMessage("Failed to copy");
      setShowPopup(true);
    }
  };

  // Initial load - Extract from knowledge_base_texts if needed
  useEffect(() => {
    if (!agentId || !isInitialLoad.current) return;

    const fetchAndSetBusinessDetails = async () => {
      let agentDetails = null;
      let businessDetails = null;

      // First try to get from store
      const res = getAgentById(agentId);

      if (res?.agentData?.agent) {
        agentDetails = res.agentData.agent;
        businessDetails = res.agentData.business;
        // Extract and set VOIP number if available
        if (agentDetails.voip_numbers) {
          try {
            const voipNumbers = JSON.parse(agentDetails.voip_numbers);
            if (voipNumbers && voipNumbers.length > 0) {
              setSelectedNumber(voipNumbers[0]);
            }
          } catch (error) {
            console.error("Error parsing voip_numbers:", error);
          }
        }
      } else {
        // If not in store, fetch from API
        try {
          const agentRequestDetails = {
            agentId: agentId,
            bussinesId: agentBuisnesId,
          };

          const response = await fetchAgentDetailById(agentRequestDetails);
          const agentInfo = response?.data;

          if (agentInfo) {
            agentDetails = agentInfo.agent;
            businessDetails = agentInfo.business;

            // Save to store
            let numbersArray = [];
            let total = 0;
            setAgentById(agentId, agentInfo, numbersArray, total);

            // Extract and set VOIP number
            if (agentInfo.voip_numbers) {
              try {
                const voipNumbers = JSON.parse(agentInfo.voip_numbers);
                if (voipNumbers && voipNumbers.length > 0) {
                  setSelectedNumber(voipNumbers[0]);
                }
              } catch (error) {
                console.error("Error parsing voip_numbers:", error);
              }
            }
          }
        } catch (err) {
          console.error("Failed to fetch data", err.response || err.message || err);
          setPopupType("error");
          setPopupMessage("Failed to load business details. Please try again.");
          setShowPopup(true);
          return;
        }
      }
    };

    fetchAndSetBusinessDetails();
    isInitialLoad.current = false;
  }, [agentId]);
  // Persist which forwarding path the user picked so reporting /
  // follow-up automations can branch on it. 'carrier' = user dialed the
  // carrier activation code on their existing phone; 'direct' = user
  // is giving the agent number out as their business line instead.
  const persistForwardingChoice = async (choice) => {
    if (!agentId) return;
    try {
      const payload = {
        forwardingType: choice,
        forwardingCarrier: choice === "carrier" ? carrier || "" : "",
      };
      // Stamp the condition detail alongside so support can replay exactly
      // which codes this user was told to dial. Only on the carrier path —
      // "direct" means they never dialed anything.
      if (choice === "carrier" && conditions.length) {
        payload.forwardingConditions = {
          carrier: carrier || "",
          mode: isUnconditional(conditions) ? "unconditional" : "conditional",
          conditions,
          forwardTo: selectedNumber || "",
          codes: forwardingSteps.map((s) => ({
            condition: s.key,
            conditions: s.conditions,
            label: s.label,
            code: s.code,
            deactivateCode: s.deactivateCode,
            order: s.order,
          })),
          dialedConditions: forwardingSteps.flatMap((s) => s.conditions),
          status: "completed",
          source: "go_live_wizard",
          completedAt: new Date().toISOString(),
        };
      }
      await updateAgent(agentId, payload);
    } catch (e) {
      console.error("Failed to persist forwardingType:", e);
    }
  };

  // Wizard fully complete on this step — drop the voip + carrier
  // caches so a brand-new agent purchase later doesn't pre-fill with
  // stale data from this run. Safe on both terminal paths
  // (handleDone + handleUsingDirectly) — removeItem is a no-op on
  // missing keys.
  const clearVoipCache = () => {
    try {
      const vk = voipKeyFor(agentId);
      if (vk) localStorage.removeItem(vk);
      // Carrier cache uses the same agentId-scoping pattern. Clean it
      // up alongside the voip cache so the next wizard run starts
      // fresh — avoids "previous run's AT&T choice" leaking into a
      // new agent's setup screen.
      if (agentId) localStorage.removeItem(`postPurchase.carrier.${agentId}`);
      // Same reasoning for the "When Call Forwarding?" selection — a new
      // agent's wizard run must start from an empty sheet.
      clearStoredConditions();
    } catch { }
  };

  const handleDone = async () => {
    if (doneLoading) return;

    setDoneLoading(true);
    await persistForwardingChoice("carrier");
    setDoneLoading(false);

    clearVoipCache();
    if (wizardMode && typeof onWizardDone === "function") {
      onWizardDone("carrier");
      return;
    }
    navigate("/fast-agent-detail", { replace: true });
  };

  // "I'm using the agent number directly" path — the user opts out of
  // carrier-side forwarding entirely and will hand the agent number out
  // as their business line.
  const handleUsingDirectly = async () => {
    if (doneLoading) return;
    setDoneLoading(true);
    await persistForwardingChoice("direct");
    setDoneLoading(false);

    clearVoipCache();
    if (wizardMode && typeof onWizardDone === "function") {
      onWizardDone("direct");
      return;
    }
    navigate("/fast-agent-detail", { replace: true });
  };

  const handleEmailTheseSteps = async () => {
    try {
      const body = {
        userId,                                    // token se decoded
        carrier,                                   // sessionStorage "selectedCarrier"
        aiPhoneNumber: selectedNumber,          // voip number (state)
        forwardingCode: getActivateInstruction(), // e.g. **21*+19104063319#
        stopForwardingCode: config.deactivate,
      };

      const response = await fetch(`${API_BASE_URL}/agent/send-forwarding-steps`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });

      const data = await response.json();
      if (data.success) {
        setPopupType("success");
        setPopupMessage("Steps sent to your email!");

      } else {
        setPopupType("error");
        setPopupMessage(data.message || "Failed to send email.");
      }
      setShowPopup(true);
    } catch (error) {
      console.error("Email send error:", error);
      setPopupType("error");
      setPopupMessage("Something went wrong.");
      setShowPopup(true);
    }
  };
  const handleClosePopup = () => {
    setShowPopup(false);
  }
  // const handleGoToDashboard = () => {
  //    navigate("/fast-agent-detail");
  // };
  // const handleGoToDashboard = () => {
  //   alert("ok")
  //   for (let i = 0; i < window.history.length; i++) {
  //     window.history.pushState(null, "", "/fast-agent-detail");
  //   }
  //   navigate("/fast-agent-detail", { replace: true });
  //   // Step 3: Back button block
  //   window.onpopstate = () => {
  //     window.history.pushState(null, "", "/fast-agent-detail");
  //   };
  // };
  const handleGoToDashboard = () => {
    // History manipulation hata do — iPhone mein issue karta hai
    navigate("/fast-agent-detail", { replace: true });
  };
  return (
    <div
      // In wizard mode the underlying CSS pins both `.bottombar` and
      // `.looksGoodBtn` to `position: absolute; bottom: x%` which was
      // sized for a single primary button on a full-screen page. Adding
      // the "using directly" CTA overflows the viewport, so we let the
      // whole container scroll and the absolute blocks sit in normal
      // flow via an override class below. No change for the standalone
      // route.
      className={`${styles.containerBox}${wizardMode ? ` ${styles.containerBoxWizard}` : ""}`}
    >
      {doneLoading && (
        <div className={styles.loadingOverlay}>
          <Loader2 />
        </div>
      )}
      <div className={styles.container}>
        {hasConditions ? (
          <>
            <div className={styles.titleBar}>
              <h4 className={styles.lightTitle}>Forward calls</h4>
              <h5 className={styles.boldTitle}>to {agentName}</h5>
            </div>
            {/* <p className={styles.ruleIntro}>
              Keep your existing business number. These codes forward calls to
              your AI receptionist.
            </p> */}
          </>
        ) : (
          <div className={styles.titleBar}>
            <h4 className={styles.lightTitle}>Manual steps for</h4>
            <h5 className={styles.boldTitle}>call forwarding</h5>
          </div>
        )}

        {/* {carrier && (
          <div className={styles.carrierInfo}>
            <p className={styles.selectedCarrier}>
              Instructions for: <strong>{carrier}</strong>
            </p>
          </div>
        )} */}

        {/* Condition rows — one per dial code the "When Call Forwarding?"
            sheet resolved to. Same layout for a single condition and for
            many; only the helper card below differs. */}
        {hasConditions ? (
          <>
            <div className={styles.StepsMain}>
              <div className={styles.stepWrapper}>
                {/* Dashed rail only connects one step to the next — with a
                    single code there is nothing to connect. */}
                {forwardingSteps.length > 1 && <div className={styles.line} />}

                {forwardingSteps.map((step) => (
                  <div className={styles.stepRow} key={step.order}>
                    <div className={styles.stepCircle}>{step.order}</div>
                    <div className={styles.stepContent}>
                      <span className={styles.ruleChip}>{step.label}</span>
                      {/* CDMA merges busy/unanswered/unreachable into one
                          code, so a row can cover several conditions — say
                          it out loud instead of looking like a lost pick. */}
                      {step.conditions.length > 1 && (
                        <p className={styles.ruleMergeNote}>
                          {carrier} uses one code for all of these.
                        </p>
                      )}
                      <div className={styles.inputBox}>
                        <input type="text" value={step.code} readOnly />
                        <span
                          className={styles.copyIcon}
                          onClick={() => handleCopyStepCode(step)}
                        >
                          <img src="/svg/copy_icon_3.svg" alt="copy_icon_3" />
                          {copiedStep === step.order && (
                            <span className={styles.copyTooltip}>Copied</span>
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* With 2+ codes the how-to sits right under the rows — the
                bottom bar only carries the confirm CTA. A single code keeps
                its "Forward My Calls Now" card, so the link stays there. */}
            {isMultiStep ? (
              <div className={styles.stepsTip}>
                <img src="/svg/tip_icon.svg" alt="" aria-hidden="true" />
                <p className={styles.stepsTipText}>
                  Dial these codes one by one from your phone's dialer to
                  activate call forwarding.
                </p>
              </div>
            ) : (
              /* Confirm link — same "Did it work?" path the single-code CTA
                 uses, so both layouts converge on one flow. */
              <button
                type="button"
                className={styles.completedLink}
                onClick={handleAllStepsDone}
                disabled={doneLoading}
              >
                I've completed these steps
              </button>
            )}
          </>
        ) : (
          <div className={styles.StepsMain}>
            <div className={styles.stepWrapper}>
              {/* Vertical Line */}
              <div className={styles.line} />

              {/* Step 1 */}
              <div className={styles.stepRow}>
                <div className={styles.stepCircle}>1</div>
                <p className={styles.stepText}>
                  Dial <strong>{getActivateInstruction()}</strong> from your{" "}
                  <span className={styles.businessPhone}>business phone</span>
                </p>
              </div>

              {/* Step 2 */}
              <div className={styles.stepRow}>
                <div className={styles.stepCircle}>2</div>
                <div className={styles.stepContent}>
                  <label className={styles.stepText}>Enter your AI phone number</label>
                  <div className={styles.inputBox}>
                    <input type="text" value={dialNumber || selectedNumber} readOnly />
                    {/* Copy icon — no default "Copy" label. On click a
                      transient "Copied" tooltip pops above the icon for
                      ~1.8s (copiedFlash). */}
                    <span className={styles.copyIcon} onClick={handleCopyNumber}>
                      <img src="/svg/copy_icon_3.svg" alt="copy_icon_3" />
                      {copiedFlash && (
                        <span className={styles.copyTooltip}>Copied</span>
                      )}
                    </span>
                  </div>
                </div>
              </div>

              {/* Step 3 */}
              <div className={styles.stepRow}>
                <div className={styles.stepCircle}>3</div>
                <p className={styles.stepText}>
                  Wait for the <b>confirmation tone</b>
                </p>
              </div>
            </div>
          </div>
        )}

        {/* Tip */}
        {/* <div className={styles.TipDiv}>
          <img src="/svg/tip_icon.svg" alt="tip_icon" />
          <p className={styles.tipText}>
            <span className={styles.TipTitle}>Tip:</span> You can stop forwarding
            anytime by dialing <strong>{config.deactivate}</strong>
          </p>
        </div> */}
        {showForwardingBanner && (
          <div className={styles.fwdBanner} ref={forwardingBannerRef}>
            <div className={styles.fwdBannerTop}>
              <span className={styles.fwdBannerIcon} aria-hidden="true">
                <svg width="59" height="59" viewBox="0 0 59 59" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <g filter="url(#filter0_d_17922_633)">
                    <circle cx="29.5" cy="29.5" r="17.5" fill="white" />
                  </g>
                  <path d="M29.9996 21C25.0297 21 21 25.0297 21 29.9996C21 34.9695 25.0297 39 29.9996 39C34.9695 39 39 34.9695 39 29.9996C39 25.0297 34.9695 21 29.9996 21ZM31.8731 34.9482C31.4099 35.131 31.0411 35.2697 30.7646 35.3657C30.4543 35.467 30.1293 35.5157 29.803 35.5097C29.2423 35.5097 28.8057 35.3726 28.4949 35.099C28.184 34.8255 28.0293 34.4789 28.0293 34.0575C28.0293 33.8937 28.0408 33.7261 28.0636 33.5554C28.0919 33.361 28.1292 33.168 28.1756 32.9771L28.7554 30.9291C28.8065 30.7326 28.8507 30.5459 28.8857 30.3722C28.9208 30.197 28.9375 30.0362 28.9375 29.8899C28.9375 29.6293 28.8834 29.4465 28.776 29.3436C28.667 29.2408 28.4621 29.1905 28.1566 29.1905C28.0072 29.1905 27.8533 29.2126 27.6956 29.259C27.5394 29.307 27.4038 29.3505 27.2926 29.3931L27.4457 28.7623C27.8251 28.6076 28.1886 28.475 28.5352 28.3653C28.8522 28.2593 29.1838 28.2032 29.5181 28.1992C30.075 28.1992 30.5048 28.3349 30.8072 28.603C31.1082 28.872 31.2598 29.2217 31.2598 29.6514C31.2598 29.7406 31.2491 29.8975 31.2286 30.1215C31.2107 30.3308 31.1719 30.5378 31.1128 30.7394L30.536 32.7813C30.4843 32.966 30.4418 33.1532 30.4088 33.3421C30.3774 33.4993 30.3588 33.6588 30.3531 33.819C30.3531 34.0903 30.4133 34.2754 30.5352 34.3737C30.6556 34.472 30.8667 34.5215 31.1653 34.5215C31.3063 34.5215 31.464 34.4964 31.6423 34.4476C31.819 34.3989 31.947 34.3554 32.0278 34.3181L31.8731 34.9482ZM31.771 26.6602C31.5088 26.9075 31.16 27.0421 30.7996 27.035C30.4217 27.035 30.0956 26.9101 29.8244 26.6602C29.6954 26.5467 29.5924 26.4068 29.5223 26.25C29.4522 26.0931 29.4167 25.923 29.4183 25.7512C29.4183 25.397 29.5554 25.0922 29.8244 24.84C30.0872 24.5907 30.4375 24.4547 30.7996 24.4613C31.1783 24.4613 31.5029 24.587 31.771 24.84C32.04 25.0922 32.1749 25.397 32.1749 25.7512C32.1749 26.107 32.04 26.4103 31.771 26.6602Z" fill="#F29A3C" />
                  <defs>
                    <filter id="filter0_d_17922_633" x="0" y="0" width="59" height="59" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
                      <feFlood flood-opacity="0" result="BackgroundImageFix" />
                      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
                      <feOffset />
                      <feGaussianBlur stdDeviation="6" />
                      <feComposite in2="hardAlpha" operator="out" />
                      <feColorMatrix type="matrix" values="0 0 0 0 0.92518 0 0 0 0 0.664128 0 0 0 0 0.38772 0 0 0 1 0" />
                      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_17922_633" />
                      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_17922_633" result="shape" />
                    </filter>
                  </defs>
                </svg>

              </span>
              <div className={styles.fwdBannerBody}>
                <p className={styles.fwdBannerTitle}>
                  Forwarding calls to <strong>{agentName}</strong>
                </p>
                <p className={styles.fwdBannerText}>
                  is <strong>very important</strong> for AI to answer your phone
                </p>
              </div>
            </div>

            <div className={styles.fwdBannerActions}>
              <button
                type="button"
                className={styles.fwdBannerTry}
                onClick={handleRetryTestCall}
              >
                Try again
              </button>
              <span className={styles.fwdBannerSep} />
              <button
                type="button"
                className={styles.fwdBannerHelp}
                onClick={() => openCallHelp("banner")}
              >
                Get help
                <span className={styles.fwdBannerArrow} aria-hidden="true">
                  →
                </span>
              </button>
            </div>
          </div>
        )}
      </div>

      {/* "Forwarding calls to {agent}" reminder banner — revealed when the
          user returns here via "Show Me the Steps Again" on the failed
          test-call screen. Carries its own Try again / Get help actions. */}


      {/* ── Multi-code helper ──
          A tel: link can only carry ONE code, so with 2+ codes there's no
          one-tap CTA to offer — just tell them to dial the copied codes one
          by one. The confirm action lives in the link above the card. */}
      {isMultiStep ? (
        <div className={`${styles.directDialCard} ${styles.multiStepBar}`}>
          <div className={styles.directDialBody}>
            <AnimatedButton
              label="I've completed these steps"
              isLoading={doneLoading}
              onClick={handleAllStepsDone}
              disabled={doneLoading}
              positionType="relative"
              width="100%"
              bottom="0px"
            />

            <p className={styles.multiStepFootTip}>
              <img src="/svg/tip_icon.svg" alt="" aria-hidden="true" />
              Disable call forwarding anytime in Phone Settings.
            </p>
          </div>
        </div>
      ) : (
        <div className={styles.directDialCard}>
          <div className={styles.directDialHeader}>
            {/* Copy differs between the condition flow and the legacy
              unconditional screen — same card, same CTA underneath. */}
            <h4 className={styles.directDialTitle}>
              {hasConditions ? (
                <>Set up <strong>from this phone</strong></>
              ) : (
                <>Direct Dial <strong>from this phone</strong></>
              )}
            </h4>
          </div>

          <div className={styles.directDialBody}>
            <p className={styles.directDialDesc}>
              {hasConditions
                ? "Open your phone dialer with the forwarding code already filled in."
                : "Tap below to open your dialer with the forwarding code ready."}
            </p>

            {/* On mobile the primary CTA opens the native dialer pre-filled
              with the activation code, then flips to "I've done this" so the
              user can confirm + advance. Desktop / tablet go straight to the
              confirm button — tel: links there open Skype/Teams which is a
              broken UX for carrier USSD codes. */}
            <AnimatedButton
              label={
                <span className={styles.forwardBtnLabel}>
                  <span className={styles.forwardBtnTitle}>Forward My Calls Now</span>
                  <span className={styles.forwardBtnSub}>
                    Opens your phone dialer with the code ready
                  </span>
                </span>
              }
              isLoading={openingDialer}
              onClick={handleForwardNowClick}
              disabled={openingDialer || doneLoading}
              positionType="relative"
              width="100%"
              bottom="0px"
            />

            <p className={styles.quickHassle}>
              {hasConditions
                ? "You'll need to press call in your phone app"
                : "Quick, Hassle Free"}
            </p>
          </div>

          {/* Alternative path — visitor hands out the agent number as their
            business line instead of forwarding their existing carrier
            number. Both CTAs persist the choice via persistForwardingChoice
            so reporting can distinguish the two. */}
          {/* {wizardMode && !hideDirectPublishCta && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 4,
              marginTop: 18,
            }}
          >
            <span
              style={{
                fontSize: 13,
                color: "#1f2937",
                fontWeight: 500,
                display: "inline-flex",
                alignItems: "center",
                gap: 6,
              }}
            >
              I will publish
              <span
                aria-hidden="true"
                style={{
                  width: 16,
                  height: 16,
                  borderRadius: "50%",
                  background: "#16A34A",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <svg width="9" height="9" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M3.5 8L6.5 11L12.5 5"
                    stroke="#fff"
                    strokeWidth="2.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              {agentName}'s number directly
            </span>
            <button
              type="button"
              onClick={handleUsingDirectly}
              disabled={doneLoading || !selectedNumber}
              style={{
                background: "transparent",
                border: "none",
                padding: "4px 8px",
                fontSize: 14,
                fontWeight: 700,
                color: "#1f2937",
                textDecoration: "underline",
                textUnderlineOffset: 3,
                cursor:
                  doneLoading || !selectedNumber ? "not-allowed" : "pointer",
                opacity: doneLoading || !selectedNumber ? 0.6 : 1,
                display: "inline-flex",
                alignItems: "center",
                gap: 0,
              }}
            >
              Skip this step
              <span aria-hidden="true">→</span>
            </button>
          </div>
        )} */}
        </div>
      )}

      {/* ════════ OLD bottom CTA block — disabled (kept for reference,
          replaced by the Direct Dial card above). Not deleted on request. ════════ */}
      {false && (
        <>
          {!wizardMode && (
            <div
              className={styles.bottombar}
              // Default CSS pins this at bottom: 13% absolute, which hides the
              // block behind the wizard header/scroll. In wizardMode we switch
              // to normal flow so it sits under the tip above the CTAs.
              style={wizardMode ? { position: "static", transform: "none", marginTop: 20, paddingInline: 0 } : undefined}
            >
              <p className={styles.desc} onClick={handleEmailTheseSteps}>Email me these steps</p>
              <div className={styles.divider}></div>
            </div>
          )}

          <div
            className={styles.looksGoodBtn}
            style={wizardMode ? { position: "fixed", bottom: "calc(10px + var(--wizard-cta-lift, 0px))", left: "50%", transform: "translateX(-50%)", width: "calc(100% - 32px)", maxWidth: "468px", zIndex: 60 } : undefined}
          >
            {isMobilePhone && !hasOpenedDialer ? (
              <AnimatedButton
                label={openingDialer ? "Opening dialer…" : "Do it now"}
                isLoading={openingDialer}
                onClick={handleForwardNowClick}
                disabled={!dialerHref || openingDialer}
                positionType={wizardMode ? "relative" : undefined}
              />
            ) : (
              <AnimatedButton
                label="I've done this"
                onClick={handleDone}
                positionType={wizardMode ? "relative" : undefined}
              />
            )}

            {wizardMode && !hideDirectPublishCta && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  gap: 4,
                }}
              >
                <span
                  style={{
                    fontSize: 13,
                    color: "#241D38",
                    fontWeight: 500,
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  I will publish
                  <span
                    aria-hidden="true"
                    style={{
                      width: 16,
                      height: 16,
                      borderRadius: "50%",
                      background: "#16A34A",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <svg width="9" height="9" viewBox="0 0 16 16" fill="none">
                      <path
                        d="M3.5 8L6.5 11L12.5 5"
                        stroke="#fff"
                        strokeWidth="2.4"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  {agentName}'s number directly
                </span>
                <button
                  type="button"
                  onClick={handleUsingDirectly}
                  disabled={doneLoading || !selectedNumber}
                  style={{
                    background: "transparent",
                    border: "none",
                    padding: "4px 8px",
                    fontSize: 14,
                    fontWeight: 700,
                    color: "#24252c",
                    textDecoration: "underline",
                    textUnderlineOffset: 3,
                    cursor:
                      doneLoading || !selectedNumber ? "not-allowed" : "pointer",
                    opacity: doneLoading || !selectedNumber ? 0.6 : 1,
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 0,
                  }}
                >
                  Skip this step
                  <span aria-hidden="true">→</span>
                </button>
              </div>
            )}
          </div>
        </>
      )}
      {/* Back button is owned by the wizard footer (PostPurchaseSetup)
          so we don't render one here anymore — the previous bottom Back
          was creating a duplicate. */}

      {/* Popup for copy feedback */}
      {showPopup && (
        <PopUp
          type={popupType}
          onClose={() => handleClosePopup()}
          message={popupMessage}

        />
      )}

      {/* "Did it work?" confirmation — reuses the shared <Modal/> shell.
          Shown after the user taps "Forward My Calls Now" so they can
          confirm forwarding actually activated (or run a test call). */}
      <Modal isOpen={showDidItWork} onClose={() => setShowDidItWork(false)} showNotch={false} showClose={false}>
        <div className={styles.didItWork}>
          <h3 className={styles.didItWorkTitle}>Did it work?</h3>
          <div className={styles.didItWorkDivider} />
          <p className={styles.didItWorkText}>
            <strong>Call forwarding</strong> is what will make your agent{" "}
            <strong>Active </strong>If it did not work, your agent will be dormant.
          </p>
          <p className={styles.didItWorkSub}>

          </p>
          <p className={styles.didItWorkConfirm}>
            Please confirm your call forwarding is working.
          </p>

          <div className={styles.didItWorkBtns}>
            <button
              type="button"
              className={styles.didItWorkNo}
              onClick={handleDidItWorkNo}
            >
              No, it didn't
            </button>
            <button
              type="button"
              className={styles.didItWorkYes}
              onClick={handleDidItWorkYes}
              disabled={doneLoading}
            >
              Yes, it did
            </button>
          </div>

          <button
            type="button"
            className={styles.testCallLink}
            onClick={openTestCall}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.6268 5.20487C15.6555 5.40519 16.601 5.90735 17.3421 6.64707C18.0833 7.38679 18.5864 8.33042 18.7871 9.35718M14.6268 1C16.7641 1.23698 18.7572 2.19226 20.2787 3.709C21.8003 5.22573 22.7599 7.21376 23 9.34667M21.9468 17.7354V20.889C21.948 21.1818 21.8879 21.4716 21.7704 21.7398C21.6529 22.0081 21.4805 22.2489 21.2644 22.4468C21.0482 22.6447 20.793 22.7954 20.5152 22.8892C20.2373 22.983 19.9429 23.0178 19.6507 22.9915C16.4098 22.64 13.2966 21.5346 10.5613 19.7642C8.01656 18.1503 5.85903 15.9968 4.24197 13.4569C2.46198 10.7145 1.35426 7.59218 1.00855 4.34287C0.982229 4.05217 1.01684 3.75919 1.11019 3.48258C1.20353 3.20597 1.35356 2.95178 1.55072 2.73621C1.74788 2.52064 1.98785 2.34841 2.25535 2.23047C2.52286 2.11254 2.81204 2.05149 3.10448 2.05122H6.26417C6.77531 2.0462 7.27084 2.22685 7.6584 2.55952C8.04595 2.89218 8.29909 3.35415 8.37063 3.85931C8.50399 4.86855 8.75132 5.85949 9.10789 6.81323C9.2496 7.18949 9.28027 7.5984 9.19626 7.99152C9.11226 8.38464 8.91711 8.74549 8.63394 9.0313L7.29633 10.3663C8.79567 12.9981 10.9789 15.1772 13.6157 16.6737L14.9533 15.3386C15.2397 15.056 15.6012 14.8612 15.9951 14.7774C16.389 14.6935 16.7987 14.7241 17.1756 14.8656C18.1312 15.2214 19.124 15.4683 20.1352 15.6014C20.6468 15.6734 21.1141 15.9307 21.4481 16.3241C21.7821 16.7176 21.9596 17.2198 21.9468 17.7354Z" fill="white" />
              <path d="M14.6268 5.20487C15.6555 5.40519 16.601 5.90735 17.3421 6.64707C18.0833 7.38679 18.5864 8.33042 18.7871 9.35718M14.6268 1C16.7641 1.23698 18.7572 2.19226 20.2787 3.709C21.8003 5.22573 22.7599 7.21376 23 9.34667M21.9468 17.7354V20.889C21.948 21.1818 21.8879 21.4716 21.7704 21.7398C21.6529 22.0081 21.4805 22.2489 21.2644 22.4468C21.0482 22.6447 20.793 22.7954 20.5152 22.8892C20.2373 22.983 19.9429 23.0178 19.6507 22.9915C16.4098 22.64 13.2966 21.5346 10.5613 19.7642C8.01656 18.1503 5.85903 15.9968 4.24197 13.4569C2.46198 10.7145 1.35426 7.59218 1.00855 4.34287C0.982229 4.05217 1.01684 3.75919 1.11019 3.48258C1.20353 3.20597 1.35356 2.95178 1.55072 2.73621C1.74788 2.52064 1.98785 2.34841 2.25535 2.23047C2.52286 2.11254 2.81204 2.05149 3.10448 2.05122H6.26417C6.77531 2.0462 7.27084 2.22685 7.6584 2.55952C8.04595 2.89218 8.29909 3.35415 8.37063 3.85931C8.50399 4.86855 8.75132 5.85949 9.10789 6.81323C9.2496 7.18949 9.28027 7.5984 9.19626 7.99152C9.11226 8.38464 8.91711 8.74549 8.63394 9.0313L7.29633 10.3663C8.79567 12.9981 10.9789 15.1772 13.6157 16.6737L14.9533 15.3386C15.2397 15.056 15.6012 14.8612 15.9951 14.7774C16.389 14.6935 16.7987 14.7241 17.1756 14.8656C18.1312 15.2214 19.124 15.4683 20.1352 15.6014C20.6468 15.6734 21.1141 15.9307 21.4481 16.3241C21.7821 16.7176 21.9596 17.2198 21.9468 17.7354Z" stroke="#00C524" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
            Not sure? Send a test call →
          </button>
        </div>
      </Modal>

      {/* "Call forwarding Help" — shown when the user taps "No, it didn't"
          on the "Did it work?" prompt. Lists the common 30-second fixes and
          a "Submit Support Ticket" exit into the ticket flow. */}
      <Modal
        isOpen={showCallHelp}
        onClose={() => setShowCallHelp(false)}
        showNotch={false}
        showClose={true}
      >
        <div className={styles.callHelp}>
          <h3 className={styles.callHelpTitle}>Call forwarding Help</h3>
          <p className={styles.callHelpSubtitle}>
            This step is crucial for AI implementation
          </p>

          <p className={styles.callHelpText}>
            <strong>{agentName}</strong> stays dormant until she is able to
            answer your business calls.
          </p>
          <p className={styles.callHelpHint}>It's usually a 30-second fix.</p>

          <div className={styles.callHelpFixes}>
            <p className={styles.callHelpFixesTitle}>Common fixes:</p>

            <div className={styles.callHelpFixesList}>
              {[
                <>
                  Dial <strong>{getActivateInstruction()}</strong> from your
                  business phone{" "}
                  <span className={styles.callHelpMuted}>(not this one)</span> and
                  wait for the confirmation tone
                </>,
                <>Make sure you picked the right carrier.</>,
                <>Verify the full 10-digit target number.</>,
                <>Restart the mobile device completely.</>,
                <>Disable Wi-Fi Calling in Settings.</>,
                <>Turn off iPhone Live Voicemail.</>,
                <> Reset network settings on the device.</>,
                <>Test the VoIP number directly first.</>,
                <> Update the phone operating system software.</>,
                <>Contact the cellular carrier for provisioning.</>,

              ].map((fix, i) => (
                <div className={styles.callHelpFixRow} key={i}>
                  <span className={styles.callHelpFixIcon} aria-hidden="true">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                      <circle cx="12" cy="12" r="10" stroke="#24252C" strokeWidth="1.5" />
                      <path
                        d="M8 12h7M12 9l3 3-3 3"
                        stroke="#24252C"
                        strokeWidth="1.6"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                  <p className={styles.callHelpFixText}>{fix}</p>
                </div>
              ))}
            </div>
          </div>

          <AnimatedButton
            label={
              <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                Submit Support Ticket
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M7.33944 13.093L5.94953 11.7166L10.1125 7.55362H-0.00146484V5.54297H10.1125L5.94953 1.38672L7.33944 0.00355083L13.8842 6.5483L7.33944 13.093Z" fill="white" />
                </svg>
              </span>
            }
            onClick={handleSubmitSupportTicket}
            positionType="relative"
            width="100%"
            bottom="-10px"
          />
        </div>
      </Modal>

      {/* "Send a Test Call" — opened from "Yes, it did" / the test-call
          link. Calls the owner's own business number; a live forward
          routes it to the agent. Reuses the shared <Modal/> shell. */}
      <Modal isOpen={showTestCall} onClose={closeTestCall} showNotch={false} showClose={false}>
        {callFailed ? (
          <div className={styles.almost}>
            <h3 className={styles.almostTitle}>Almost there</h3>
            <p className={styles.almostSubtitle}>forwarding isn't active yet</p>

            <p className={styles.almostText}>
              <strong>{agentName}</strong> didn't pick up, so your calls aren't
              reaching her yet. Your agent stays dormant until this works.
            </p>
            <p className={styles.almostHint}>It's usually a 30-second fix.</p>

            <div className={styles.almostFixes}>
              <p className={styles.almostFixesTitle}>Common fixes:</p>
              <div className={styles.almostFixRow}>
                <span className={styles.almostFixIcon}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <circle cx="12" cy="12" r="9" stroke="#24252C" strokeWidth="1.6" />
                    <path d="M9.5 12h5M12.5 9.5l2.5 2.5-2.5 2.5" stroke="#24252C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
                <p className={styles.almostFixText}>
                  Dial <strong>{getActivateInstruction()}</strong> from your
                  business phone <span className={styles.almostMuted}>(not this one)</span> and
                  wait for the confirmation tone
                </p>
              </div>
              <div className={styles.almostFixRow}>
                <span className={styles.almostFixIcon}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <circle cx="12" cy="12" r="9" stroke="#24252C" strokeWidth="1.6" />
                    <path d="M9.5 12h5M12.5 9.5l2.5 2.5-2.5 2.5" stroke="#24252C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                </span>
                <p className={styles.almostFixText}>
                  Make sure you picked the right carrier
                </p>
              </div>
            </div>

            <div className={styles.almostNextBtnWrap}>
              <AnimatedButton
                label="Show Me the Steps Again →"
                onClick={handleShowStepsAgain}
                positionType="relative"
                width="100%"
                bottom="0px"
              />
            </div>

            <div className={styles.almostActions}>
              <button
                type="button"
                className={styles.almostActionBtn}
                onClick={handleTestCallAgain}
              >
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M14.6268 5.20487C15.6555 5.40519 16.601 5.90735 17.3421 6.64707C18.0833 7.38679 18.5864 8.33042 18.7871 9.35718M14.6268 1C16.7641 1.23698 18.7572 2.19226 20.2787 3.709C21.8003 5.22573 22.7599 7.21376 23 9.34667M21.9468 17.7354V20.889C21.948 21.1818 21.8879 21.4716 21.7704 21.7398C21.6529 22.0081 21.4805 22.2489 21.2644 22.4468C21.0482 22.6447 20.793 22.7954 20.5152 22.8892C20.2373 22.983 19.9429 23.0178 19.6507 22.9915C16.4098 22.64 13.2966 21.5346 10.5613 19.7642C8.01656 18.1503 5.85903 15.9968 4.24197 13.4569C2.46198 10.7145 1.35426 7.59218 1.00855 4.34287C0.982229 4.05217 1.01684 3.75919 1.11019 3.48258C1.20353 3.20597 1.35356 2.95178 1.55072 2.73621C1.74788 2.52064 1.98785 2.34841 2.25535 2.23047C2.52286 2.11254 2.81204 2.05149 3.10448 2.05122H6.26417C6.77531 2.0462 7.27084 2.22685 7.6584 2.55952C8.04595 2.89218 8.29909 3.35415 8.37063 3.85931C8.50399 4.86855 8.75132 5.85949 9.10789 6.81323C9.2496 7.18949 9.28027 7.5984 9.19626 7.99152C9.11226 8.38464 8.91711 8.74549 8.63394 9.0313L7.29633 10.3663C8.79567 12.9981 10.9789 15.1772 13.6157 16.6737L14.9533 15.3386C15.2397 15.056 15.6012 14.8612 15.9951 14.7774C16.389 14.6935 16.7987 14.7241 17.1756 14.8656C18.1312 15.2214 19.124 15.4683 20.1352 15.6014C20.6468 15.6734 21.1141 15.9307 21.4481 16.3241C21.7821 16.7176 21.9596 17.2198 21.9468 17.7354Z" fill="white" />
                  <path d="M14.6268 5.20487C15.6555 5.40519 16.601 5.90735 17.3421 6.64707C18.0833 7.38679 18.5864 8.33042 18.7871 9.35718M14.6268 1C16.7641 1.23698 18.7572 2.19226 20.2787 3.709C21.8003 5.22573 22.7599 7.21376 23 9.34667M21.9468 17.7354V20.889C21.948 21.1818 21.8879 21.4716 21.7704 21.7398C21.6529 22.0081 21.4805 22.2489 21.2644 22.4468C21.0482 22.6447 20.793 22.7954 20.5152 22.8892C20.2373 22.983 19.9429 23.0178 19.6507 22.9915C16.4098 22.64 13.2966 21.5346 10.5613 19.7642C8.01656 18.1503 5.85903 15.9968 4.24197 13.4569C2.46198 10.7145 1.35426 7.59218 1.00855 4.34287C0.982229 4.05217 1.01684 3.75919 1.11019 3.48258C1.20353 3.20597 1.35356 2.95178 1.55072 2.73621C1.74788 2.52064 1.98785 2.34841 2.25535 2.23047C2.52286 2.11254 2.81204 2.05149 3.10448 2.05122H6.26417C6.77531 2.0462 7.27084 2.22685 7.6584 2.55952C8.04595 2.89218 8.29909 3.35415 8.37063 3.85931C8.50399 4.86855 8.75132 5.85949 9.10789 6.81323C9.2496 7.18949 9.28027 7.5984 9.19626 7.99152C9.11226 8.38464 8.91711 8.74549 8.63394 9.0313L7.29633 10.3663C8.79567 12.9981 10.9789 15.1772 13.6157 16.6737L14.9533 15.3386C15.2397 15.056 15.6012 14.8612 15.9951 14.7774C16.389 14.6935 16.7987 14.7241 17.1756 14.8656C18.1312 15.2214 19.124 15.4683 20.1352 15.6014C20.6468 15.6734 21.1141 15.9307 21.4481 16.3241C21.7821 16.7176 21.9596 17.2198 21.9468 17.7354Z" stroke="#24252c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                Test call again
              </button>
              <span className={styles.almostDivider} />
              <button
                type="button"
                className={styles.almostActionBtn}
                onClick={handleFailedGetHelp}
              >
                Get help →
              </button>
            </div>
          </div>





          // <div className={styles.liveSuccess}>
          //   <div className={styles.liveHeader}>
          //     <span className={styles.liveCheck}>
          //       <svg width="18" height="18" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          //         <path
          //           d="M3.5 8L6.5 11L12.5 5"
          //           stroke="#fff"
          //           strokeWidth="2.4"
          //           strokeLinecap="round"
          //           strokeLinejoin="round"
          //         />
          //       </svg>
          //     </span>
          //     <h3 className={styles.liveTitle}>You're live!</h3>
          //   </div>

          //   <p className={styles.almostText}>
          //     <strong>{agentName}</strong> didn't pick up, so your calls aren't
          //     reaching her yet. Your agent stays dormant until this works.
          //   </p>
          //   <p className={styles.almostHint}>It's usually a 30-second fix.</p>

          //   <div className={styles.almostFixes}>
          //     <p className={styles.almostFixesTitle}>Common fixes:</p>
          //     <div className={styles.almostFixRow}>
          //       <span className={styles.almostFixIcon}>
          //         <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          //           <circle cx="12" cy="12" r="9" stroke="#24252C" strokeWidth="1.6" />
          //           <path d="M9.5 12h5M12.5 9.5l2.5 2.5-2.5 2.5" stroke="#24252C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
          //         </svg>
          //       </span>
          //       <p className={styles.almostFixText}>
          //         Dial <strong>{getActivateInstruction()}</strong> from your
          //         business phone <span className={styles.almostMuted}>(not this one)</span> and
          //         wait for the confirmation tone
          //       </p>
          //     </div>
          //     <div className={styles.almostFixRow}>
          //       <span className={styles.almostFixIcon}>
          //         <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          //           <circle cx="12" cy="12" r="9" stroke="#24252C" strokeWidth="1.6" />
          //           <path d="M9.5 12h5M12.5 9.5l2.5 2.5-2.5 2.5" stroke="#24252C" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
          //         </svg>
          //       </span>
          //       <p className={styles.almostFixText}>
          //         Make sure you picked the right carrier
          //       </p>
          //     </div>
          //   </div>

          //   <div className={styles.almostNextBtnWrap}>
          //     <AnimatedButton
          //       label="Show Me the Steps Again →"
          //       onClick={handleShowStepsAgain}
          //       positionType="relative"
          //       width="100%"
          //       bottom="0px"
          //     />
          //   </div>

          //   <div className={styles.almostActions}>
          //     <button
          //       type="button"
          //       className={styles.almostActionBtn}
          //       onClick={handleRetryTestCall}
          //     >
          //       <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          //         <path d="M14.6268 5.20487C15.6555 5.40519 16.601 5.90735 17.3421 6.64707C18.0833 7.38679 18.5864 8.33042 18.7871 9.35718M14.6268 1C16.7641 1.23698 18.7572 2.19226 20.2787 3.709C21.8003 5.22573 22.7599 7.21376 23 9.34667M21.9468 17.7354V20.889C21.948 21.1818 21.8879 21.4716 21.7704 21.7398C21.6529 22.0081 21.4805 22.2489 21.2644 22.4468C21.0482 22.6447 20.793 22.7954 20.5152 22.8892C20.2373 22.983 19.9429 23.0178 19.6507 22.9915C16.4098 22.64 13.2966 21.5346 10.5613 19.7642C8.01656 18.1503 5.85903 15.9968 4.24197 13.4569C2.46198 10.7145 1.35426 7.59218 1.00855 4.34287C0.982229 4.05217 1.01684 3.75919 1.11019 3.48258C1.20353 3.20597 1.35356 2.95178 1.55072 2.73621C1.74788 2.52064 1.98785 2.34841 2.25535 2.23047C2.52286 2.11254 2.81204 2.05149 3.10448 2.05122H6.26417C6.77531 2.0462 7.27084 2.22685 7.6584 2.55952C8.04595 2.89218 8.29909 3.35415 8.37063 3.85931C8.50399 4.86855 8.75132 5.85949 9.10789 6.81323C9.2496 7.18949 9.28027 7.5984 9.19626 7.99152C9.11226 8.38464 8.91711 8.74549 8.63394 9.0313L7.29633 10.3663C8.79567 12.9981 10.9789 15.1772 13.6157 16.6737L14.9533 15.3386C15.2397 15.056 15.6012 14.8612 15.9951 14.7774C16.389 14.6935 16.7987 14.7241 17.1756 14.8656C18.1312 15.2214 19.124 15.4683 20.1352 15.6014C20.6468 15.6734 21.1141 15.9307 21.4481 16.3241C21.7821 16.7176 21.9596 17.2198 21.9468 17.7354Z" stroke="#24252c" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          //       </svg>
          //       Test call again
          //     </button>
          //     <span className={styles.almostDivider} />
          //     <button
          //       type="button"
          //       className={styles.almostActionBtn}
          //       onClick={handleFailedGetHelp}
          //     >
          //       Get help →
          //     </button>
          //   </div>
          // </div>
        ) : callSuccess ? (
          <div className={styles.liveSuccess}>
            <div className={styles.liveHeader}>
              <span className={styles.liveCheck}>
                <svg width="18" height="18" viewBox="0 0 16 16" fill="none" aria-hidden="true">
                  <path
                    d="M3.5 8L6.5 11L12.5 5"
                    stroke="#fff"
                    strokeWidth="2.4"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
              <h3 className={styles.liveTitle}>You're live!</h3>
            </div>

            <p className={styles.liveText}>
              <strong>{agentName}</strong> just answered on your business line.
              Call forwarding is working perfectly.
            </p>
            <p className={styles.liveSubText}>
              From now on she's catching your calls 24/7, even when you can't
              pick up.
            </p>

            <AnimatedButton
              label="Next: Set Up Call Triage →"
              onClick={handleNextTriage}
              disabled={doneLoading}
              positionType="relative"
              width="100%"
              bottom="0px"
            />

            <p className={styles.liveFootnote}>
              Your agent is now Active on your business phone
            </p>
          </div>
        ) : callConnecting ? (
          <div className={styles.connecting}>
            <h3 className={styles.connectingTitle}>Connecting Call...</h3>
            <p className={styles.connectingSub}>
              Checking if <strong>"{agentName}"</strong> answers your business
              phone.
            </p>

            <div className={styles.testCallDashDivider} />

            <div className={styles.connectingRow}>
              <div className={styles.connectingAvatar}>
                <img src="/svg/fav_icon.svg" alt="" />
              </div>

              <div className={styles.connectingMid}>
                <div className={styles.connectingWaitLine}>
                  <span className={styles.connectingWait}>PLEASE WAIT...</span>
                  <span className={styles.connectingArrows}>
                    <svg width="40" height="16" viewBox="0 0 40 16" fill="none" aria-hidden="true">
                      <path d="M4 3l5 5-5 5M15 3l5 5-5 5M26 3l5 5-5 5" stroke="#3DC55B" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </span>
                </div>
                <span className={styles.connectingCalling}>
                  calling your number now.
                </span>
              </div>

              <div className={styles.connectingPhone}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path
                    d="M6.8 3.2h2.3l1.25 3.3-1.7 1.25a11 11 0 0 0 4.4 4.4l1.25-1.7 3.3 1.25v2.3a1.8 1.8 0 0 1-1.95 1.8A14.5 14.5 0 0 1 5 5.15 1.8 1.8 0 0 1 6.8 3.2z"
                    stroke="#16A34A"
                    strokeWidth="1.7"
                    strokeLinejoin="round"
                  />
                  <path d="M15.5 4.5a4 4 0 0 1 3.5 3.5M15.5 1.6a7 7 0 0 1 6.4 6.4" stroke="#16A34A" strokeWidth="1.7" strokeLinecap="round" />
                </svg>
              </div>
            </div>

            <span className={styles.connectingNumber}>{callDisplayNumber}</span>

            <button
              type="button"
              className={styles.goBackLink}
              onClick={closeTestCall}
            >
              &lt;&lt;&lt; Go Back to Call Forwarding
            </button>
          </div>
        ) : (
          <div className={styles.testCall}>
            <h3 className={styles.testCallTitle}>Send a Test Call</h3>
            <p className={styles.testCallText}>
              We'll call your <strong>business number</strong>
            </p>
            <p className={styles.testCallSub}>
              If forwarding is set up, <strong>{agentName}</strong> will answers it.
            </p>

            <div className={styles.testCallDashDivider} />

            <div className={styles.testCallNumberRow}>
              {editingTestNumber ? (
                <input
                  type="tel"
                  inputMode="tel"
                  className={styles.testCallInput}
                  value={testCallNumber}
                  onChange={handleTestNumberChange}
                  onKeyPress={(e) => {
                    // Block letters/symbols at the keystroke level too, so
                    // nothing flashes in before the sanitiser runs.
                    if (!/[\d+\s()-]/.test(e.key)) e.preventDefault();
                  }}
                  onBlur={() => setEditingTestNumber(false)}
                  placeholder="+1 000-000-0000"
                  maxLength={20}
                  autoFocus
                />
              ) : (
                <span className={styles.testCallNumber}>
                  {testCallNumber || "Add your number"}
                </span>
              )}
              <button
                type="button"
                className={styles.testCallEdit}
                onClick={() => setEditingTestNumber((v) => !v)}
                aria-label="Edit number"
              >
                <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M10.9996 20.1641C10.2851 20.1641 9.70429 20.6496 9.69922 21.2471C9.69922 21.8488 10.2749 22.3343 10.9945 22.3386L19.7973 22.3641H19.8024C20.5169 22.3641 21.0977 21.8785 21.1027 21.281C21.1027 20.6794 20.5271 20.1938 19.8075 20.1895L11.0046 20.1641H10.9996Z" fill="black" />
                  <path d="M0 16.8123V22H5.17972L22 5.18037L16.8203 0L0 16.8123ZM4.4206 20.1666H1.8337V17.5716L14.2227 5.18887L16.8132 7.77429L4.4206 20.1666ZM18.1096 6.47905L15.5191 3.89364L16.8203 2.59257L19.4085 5.1804L18.1096 6.47905Z" fill="black" />
                </svg>

              </button>
            </div>

            {testCallNumber && !isTestCallValid && (
              <p className={styles.testCallError}>
                {isIndiaTestCall
                  ? "Enter a valid number starting with +91 (12 digits including country code)."
                  : "Enter a valid number starting with +1 (11 digits including country code)."}
              </p>
            )}

            <p className={styles.testCallConfirm}>
              Confirm your number &amp; tap <strong>Call Now</strong>
            </p>

            <AnimatedButton
              label={
                <span style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                  Call Now
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                    <path d="M7.33944 13.093L5.94953 11.7166L10.1125 7.55362H-0.00146484V5.54297H10.1125L5.94953 1.38672L7.33944 0.00355083L13.8842 6.5483L7.33944 13.093Z" fill="white" />
                  </svg>
                </span>
              }
              onClick={handleCallNow}
              bgSrc="svg/svg-theme-green.svg"
              disabled={!isTestCallValid}
              positionType="relative"
              width="100%"
              bottom="0px"
            />

            <button
              type="button"
              className={styles.goBackLink}
              onClick={closeTestCall}
            >
              &lt;&lt;&lt; Go Back to Call Forwarding
            </button>
          </div>
          // <div className={styles.connecting}>
          //   <h3 className={styles.connectingTitle}>Connecting Call...</h3>
          //   <p className={styles.connectingSub}>
          //     Checking if <strong>"{agentName}"</strong> answers your business
          //     phone.
          //   </p>

          //   <div className={styles.testCallDashDivider} />

          //   <div className={styles.connectingRow}>
          //     <div className={styles.connectingAvatar}>
          //       <img src="/svg/fav_icon.svg" alt="" />
          //     </div>

          //     <div className={styles.connectingMid}>
          //       <div className={styles.connectingWaitLine}>
          //         <span className={styles.connectingWait}>PLEASE WAIT...</span>
          //         <span className={styles.connectingArrows}>›››</span>
          //       </div>
          //       <span className={styles.connectingCalling}>
          //         calling your number now.
          //       </span>
          //       <span className={styles.connectingNumber}>{callDisplayNumber}</span>
          //     </div>

          //     <div className={styles.connectingPhone}>
          //       <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          //         <path d="M14.6268 5.20487C15.6555 5.40519 16.601 5.90735 17.3421 6.64707C18.0833 7.38679 18.5864 8.33042 18.7871 9.35718M14.6268 1C16.7641 1.23698 18.7572 2.19226 20.2787 3.709C21.8003 5.22573 22.7599 7.21376 23 9.34667M21.9468 17.7354V20.889C21.948 21.1818 21.8879 21.4716 21.7704 21.7398C21.6529 22.0081 21.4805 22.2489 21.2644 22.4468C21.0482 22.6447 20.793 22.7954 20.5152 22.8892C20.2373 22.983 19.9429 23.0178 19.6507 22.9915C16.4098 22.64 13.2966 21.5346 10.5613 19.7642C8.01656 18.1503 5.85903 15.9968 4.24197 13.4569C2.46198 10.7145 1.35426 7.59218 1.00855 4.34287C0.982229 4.05217 1.01684 3.75919 1.11019 3.48258C1.20353 3.20597 1.35356 2.95178 1.55072 2.73621C1.74788 2.52064 1.98785 2.34841 2.25535 2.23047C2.52286 2.11254 2.81204 2.05149 3.10448 2.05122H6.26417C6.77531 2.0462 7.27084 2.22685 7.6584 2.55952C8.04595 2.89218 8.29909 3.35415 8.37063 3.85931C8.50399 4.86855 8.75132 5.85949 9.10789 6.81323C9.2496 7.18949 9.28027 7.5984 9.19626 7.99152C9.11226 8.38464 8.91711 8.74549 8.63394 9.0313L7.29633 10.3663C8.79567 12.9981 10.9789 15.1772 13.6157 16.6737L14.9533 15.3386C15.2397 15.056 15.6012 14.8612 15.9951 14.7774C16.389 14.6935 16.7987 14.7241 17.1756 14.8656C18.1312 15.2214 19.124 15.4683 20.1352 15.6014C20.6468 15.6734 21.1141 15.9307 21.4481 16.3241C21.7821 16.7176 21.9596 17.2198 21.9468 17.7354Z" fill="white" />
          //         <path d="M14.6268 5.20487C15.6555 5.40519 16.601 5.90735 17.3421 6.64707C18.0833 7.38679 18.5864 8.33042 18.7871 9.35718M14.6268 1C16.7641 1.23698 18.7572 2.19226 20.2787 3.709C21.8003 5.22573 22.7599 7.21376 23 9.34667M21.9468 17.7354V20.889C21.948 21.1818 21.8879 21.4716 21.7704 21.7398C21.6529 22.0081 21.4805 22.2489 21.2644 22.4468C21.0482 22.6447 20.793 22.7954 20.5152 22.8892C20.2373 22.983 19.9429 23.0178 19.6507 22.9915C16.4098 22.64 13.2966 21.5346 10.5613 19.7642C8.01656 18.1503 5.85903 15.9968 4.24197 13.4569C2.46198 10.7145 1.35426 7.59218 1.00855 4.34287C0.982229 4.05217 1.01684 3.75919 1.11019 3.48258C1.20353 3.20597 1.35356 2.95178 1.55072 2.73621C1.74788 2.52064 1.98785 2.34841 2.25535 2.23047C2.52286 2.11254 2.81204 2.05149 3.10448 2.05122H6.26417C6.77531 2.0462 7.27084 2.22685 7.6584 2.55952C8.04595 2.89218 8.29909 3.35415 8.37063 3.85931C8.50399 4.86855 8.75132 5.85949 9.10789 6.81323C9.2496 7.18949 9.28027 7.5984 9.19626 7.99152C9.11226 8.38464 8.91711 8.74549 8.63394 9.0313L7.29633 10.3663C8.79567 12.9981 10.9789 15.1772 13.6157 16.6737L14.9533 15.3386C15.2397 15.056 15.6012 14.8612 15.9951 14.7774C16.389 14.6935 16.7987 14.7241 17.1756 14.8656C18.1312 15.2214 19.124 15.4683 20.1352 15.6014C20.6468 15.6734 21.1141 15.9307 21.4481 16.3241C21.7821 16.7176 21.9596 17.2198 21.9468 17.7354Z" stroke="#00C524" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          //       </svg>
          //     </div>
          //   </div>

          //   {/* <button
          //     type="button"
          //     className={styles.goBackLink}
          //     onClick={closeTestCall}
          //   >
          //     &lt;&lt;&lt; Go Back to Call Forwarding
          //   </button> */}
          // </div>
        )}
      </Modal>
    </div>
  );
};

export default ForwardInstructions;
// 
